import React, { useState, useEffect, useRef } from "react";
import Skeleton from "react-loading-skeleton";
import ReactTooltip from "react-tooltip";
 import moment from "moment";
// import { Base64 } from "js-base64";
import "./ItineraryDetails.css";
import  ListingSkeleton  from './ListingSkeleton';
import  DetailsSkeleton  from './DetailsSkeleton';
 import { LazyLoadImage } from 'react-lazy-load-image-component';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import ImageGallery from "react-image-gallery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import DayPicker from "react-day-picker";
import Collapsible from "react-collapsible";
import "react-day-picker/lib/style.css";
import {
  faEuroSign,
  faMapMarkedAlt,
  faHotel,
  faPlane,
  faShip,
  faBus

} from "@fortawesome/free-solid-svg-icons";
import {
  faCalendarCheck,
  faUserCircle,
} from "@fortawesome/free-regular-svg-icons";
import {
  getTourTransferFerryTriplist,
  TransferDetailsData,
  CheckAvailabilityData
} from "../axios";
import { connect, Provider, useDispatch, useSelector } from 'react-redux';
import { createStore } from "redux";
import { addToCart, clearToCart, updateToCart } from "../../redux/actions/actions";
const SortArr = [
  { id: "4", name: "Recommended" },
  { id: "1", name: "Price - Low to High" },
  { id: "2", name: "Price - High to Low" },
];

const ListNumber = [
  { id: "1" },
  { id: "2" },
  { id: "3" },
  { id: "4" },
  { id: "5" },
  { id: "6" },
  { id: "7" },
  { id: "8" },
  { id: "9" },
  { id: "10" },
  { id: "11" },
  { id: "12" },
  { id: "13" },
  { id: "14" },
  { id: "15" },
  { id: "16" },
  { id: "17" },
  { id: "18" },
  { id: "19" },
  { id: "20" },
  { id: "21" },
  { id: "22" },
  { id: "23" },
  { id: "24" },
  { id: "25" },
];

const ListNumberNew = [
  { id: "0" },
  { id: "1" },
  { id: "2" },
  { id: "3" },
  { id: "4" },
  { id: "5" },
  { id: "6" },
  { id: "7" },
  { id: "8" },
  { id: "9" },
  { id: "10" },
  { id: "11" },
  { id: "12" },
  { id: "13" },
  { id: "14" },
  { id: "15" },
  { id: "16" },
  { id: "17" },
  { id: "18" },
  { id: "19" },
  { id: "20" },
  { id: "21" },
  { id: "22" },
  { id: "23" },
  { id: "24" },
];

const scrollToRef = (ref) =>
  window.scrollTo({
    top: 280,
    left: 100,
    behavior: "smooth",
  });
function ExperienceTransferFerryListingPopup(props) {
  const dispatch = useDispatch();
  const [openAttractionDetails, setopenAttractionDetails] = useState("ACCL");
  const [transferData, settransferData] = useState(null);
  const [transferListFilter, settransferListFilter] = useState([]);
  const [totalactivityData, settotalactivityData] = useState([]);
  const [totalcount, settotalcount] = useState(0);
  const [SkeletonData, setSkeletonData] = useState(false);
  const [sorting, setsorting] = useState(false);
  const [sortingSelect, setsortingSelect] = useState("Recommended");
  const [loading, setloading] = useState(false);
  const [selectActivityDayNew, setselectActivityDayNew] = useState(new Date());
  const [ImageChanger, setImageChanger] = useState();
 
  // ===============================Details Activity==============================
  const [tourdataDetails, settourdataDetails] = useState("");
  const [tourDescriptionDetails, settourDescriptionDetails] = useState("");
  const [tourPriceDetails, settourPriceDetails] = useState("");
  const [tourGalleryDetails, settourGalleryDetails] = useState([]);
  const [tourExtrachargesDetails, settourExtrachargesDetails] = useState("");
  const [tourInclusionDetails, settourInclusionDetails] = useState([]);
  const [tourExclusionDetails, settourExclusionDetails] = useState([]);
  const [tourMeetingpointDetails, settourMeetingpointDetails] = useState("");
  const [tourCancellationPolicyDetails, settourCancellationPolicyDetails] = useState(null);
  const [tourFreeCancellationPolicyDetails, settourFreeCancellationPolicyDetails] = useState(null);
  const [tourItineraryDetails, settourItineraryDetails] = useState(null);
  const [tourTransportDetails, settourTransportDetails] = useState(null);
  const [tourSingleTourGalleryDetails, settourSingleTourGalleryDetails] = useState([]);
  const [error,  setError] = useState(null);
  const [selectActivityDayNewDetails, setselectActivityDayNewDetails] = useState(new Date());
  const [selectActivityDayDetails, setselectActivityDayDetails] = useState(moment(new Date()).format("dddd, MMM D, YYYY"));
  const [checkinShowActivity, setcheckinShowActivity] = useState(false);
  const [dropdownVisible, setdropdownVisible] = useState(false);
  const [numberTraveler, setnumberTraveler] = useState("Number of travelers");
  const [carts, setcarts] = useState([{
    adultCounter: 1,
    infantCounter: 0,
    childCounter: 0,
    youthCounter: 0,
    seniorCounter: 0,
    groupCounter: 1,
  },]);
 
  const [errMessage, seterrMessage] = useState(false);
  const [show_options, setshow_options] = useState(false);
  const [tour_options, settour_options] = useState(false);
  const [checkName, setcheckName] = useState("Check Availability");
  const [selectedIndex, setselectedIndex] = useState(null);
  const [buttonDisabled, setbuttonDisabled] = useState("disabled");
  const [selectedIndexNew, setselectedIndexNew] = useState(null);
  const [sortingSelectTour, setsortingSelectTour] = useState("Recommended");
  const [sortingIdTour, setsortingIdTour] = useState(null);
  const [tourIDDetails, settourIDDetails] = useState(null);
  const [selectedTime, setselectedTime] = useState(1);
  const [selectedTimeValue, setselectedTimeValue] = useState();
  const [cartcheckAvailability, setcartcheckAvailability] = useState([]);
  const [CartIndexNumber, setCartIndexNumber] = useState(null);
  const [DisableSelectButton, setDisableSelectButton] = useState(false);
  const [slideShowTransferFerry, setslideShowTransferFerry] = useState(localStorage.setItem('transferFerrySlide', true));
  const myDivToFocus = React.createRef();

  const selectedData = useSelector((state) => state.cardItems.cardData);
  const selectedDataNew = useSelector((state) => state);
  const [countDetails, setcountDetails] = useState(0);
 useEffect(() => {
    const transferArr = props?.experiencetransfer;
const JSONObject = JSON.parse(transferArr);
setCartIndexNumber(JSONObject.IndexNumber);

setselectActivityDayNew(JSONObject.dateSelected);
setselectActivityDayNewDetails(JSONObject.dateSelected);
getTourTransferFerryTriplist(transferArr).then(
      (data) => {
        //console.log(data);
        if (data == undefined) {
          settransferData(null);
        } else {
          settransferListFilter(data);
          if (data == "no_transfer") {
            settransferData(data);
          } else {
           settransferData(data);
           settransferListFilter(data);
          }
        }
   
      },

      // (error) => {
      //   this.setState({
      //     error,
      //   });
      // }
    );

   // };

 },[props?.experience])

 
 const handleClick = (
  i,
  tour_id,
  selectedDate,
  galleryimage,
  selectedForTime,
  ratePlanId,
  numberTraveler,
  tour_name,
  option_name,
  tour_location,
  time,
  price_type,
  tour_operator_id,
  extracharges,
  cancellationpolicy,
  freecancellationpolicy
) => {
  setDisableSelectButton(true);
     //Paylater Function
    const selectActivityDay = selectActivityDayDetails;
    let firstcancellationdate = "";
    let paylater = "";
    if(freecancellationpolicy.length >0 ){
        let freeDate= freecancellationpolicy[0]?.day_before_arrival;
        let cancellationDate = moment(selectActivityDay).subtract(freeDate, 'days').format("YYYY-MM-D")
        let NewFreeConstDate = moment(cancellationDate).subtract(15, 'days').format("YYYY-MM-D");
        let currentDate = new Date();
        let NewcurrentDate =  moment(currentDate).format("YYYY-MM-D");
          if(NewFreeConstDate >= NewcurrentDate){
            firstcancellationdate = cancellationDate;
            paylater = 1
          }else{
            firstcancellationdate = cancellationDate;
          }
    }
  let OfferAn = "";
  if (i.specialOffer != "no_offer") {
    i.specialOffer.map((l, j) => {
      if (l.combineoffer == "nocombine") {
        OfferAn = {
          offerName: l.name,
          rateDiscount: l.ratediscount,
          OfferId: l.OfferID,
        };
      } else {
        l.specialOffer.combineoffer
          .map((k, j) => {
            OfferAn = {
              offerName: l.combineoffer[j].name,
              rateDiscount: l.combineoffer[j].ratediscount,
              OfferId: l.combineoffer[j].OfferID,
            };
          })
          .join(",");
      }
    });
  }
  let TPrice = 0;

  let Traveller = 0;

  i.price[0].map((item, index) => {
    if (item.group_price > 0) {
      if (item.flexible_id == 0) {
        let GroupTraveler = carts.reduce(
          (a, v) => a + v.groupCounter * 1,
          0
        );

        Traveller = GroupTraveler;

        if (GroupTraveler <= item.group_max) {
          if (i.specialOffer != "no_offer") {
            let result = [];

            i.specialOffer.map((l, j) => {
              if (l.combineoffer == "nocombine") {
                if (l.specialdata.discount_id == 2) {
                  const disA = l.specialdata.rate_amount;
                  result.push(+disA);
                } else {
                  const disA = item.group_price - l.specialdata.rate_amount;
                  result.push(+disA);
                }
              } else {
                if (l.specialdata.discount_id == 2) {
                  const disA = l.specialdata.rate_amount;
                  result.push(+disA);
                } else {
                  const disA = item.group_price - l.specialdata.rate_amount;
                  result.push(+disA);
                }
              }
            });

            const Amount = result.reduce((a, v) => a + v * 1, 0).toFixed(2);
            const $UpliftAmountGroup =
              (parseInt(i.priceuplift[0]) / 100) * item.group_price;
            const UpliftGroupAmount =
              parseInt(item.group_price) + $UpliftAmountGroup;

            const balanceAmount =
              UpliftGroupAmount -
              (Math.round(Amount * UpliftGroupAmount) / 100).toFixed(2);

            TPrice = balanceAmount;
          } else {
            const $UpliftAmountGroup =
              (parseInt(i.priceuplift[0]) / 100) * item.group_price;
            const UpliftGroupAmount =
              parseInt(item.group_price) + $UpliftAmountGroup;
            TPrice = UpliftGroupAmount;
            //TPrice = item.group_price;
          }
        }
      } else {
        let GroupTraveler = carts.reduce(
          (a, v) => a + v.groupCounter * 1,
          0
        );

        Traveller = GroupTraveler;

        if (
          GroupTraveler <= item.group_max &&
          GroupTraveler >= item.group_min
        ) {
          if (i.specialOffer != "no_offer") {
            let result = [];

            i.specialOffer.map((l, j) => {
              if (l.combineoffer == "nocombine") {
                if (l.specialdata.discount_id == 2) {
                  const disA = l.specialdata.rate_amount;
                  result.push(+disA);
                } else {
                  const disA = item.group_price - l.specialdata.rate_amount;
                  result.push(+disA);
                }
              } else {
                if (l.specialdata.discount_id == 2) {
                  const disA = l.specialdata.rate_amount;
                  result.push(+disA);
                } else {
                  const disA = item.group_price - l.specialdata.rate_amount;
                  result.push(+disA);
                }
              }
            });

            const Amount = result.reduce((a, v) => a + v * 1, 0).toFixed(2);
            const $UpliftAmountGroup =
              (parseInt(i.priceuplift[0]) / 100) * item.group_price;
            const UpliftGroupAmount =
              parseInt(item.group_price) + $UpliftAmountGroup;

            const balanceAmount =
              UpliftGroupAmount -
              (Math.round(Amount * UpliftGroupAmount) / 100).toFixed(2);

            TPrice = balanceAmount;
          } else {
            const $UpliftAmountGroup =
              (parseInt(i.priceuplift[0]) / 100) * item.group_price;
            const UpliftGroupAmount =
              parseInt(item.group_price) + $UpliftAmountGroup;
            TPrice = UpliftGroupAmount;
            //TPrice = item.group_price;
          }
        }
      }
    } else {
      let total = "";

      if (item.flexible_id == 0) {
        let adult_P = 0;
        let adultTraveler = carts.reduce(
          (a, v) => a + v.adultCounter * 1,
          0
        );
        let infantTraveler = carts.reduce(
          (a, v) => a + v.infantCounter * 1,
          0
        );
        let childTraveler = carts.reduce(
          (a, v) => a + v.childCounter * 1,
          0
        );
        let youthTraveler = carts.reduce(
          (a, v) => a + v.youthCounter * 1,
          0
        );
        let seniorTraveler = carts.reduce(
          (a, v) => a + v.seniorCounter * 1,
          0
        );

        Traveller =
          adultTraveler * 1 +
          infantTraveler * 1 +
          childTraveler * 1 +
          youthTraveler * 1 +
          seniorTraveler * 1;

        if (item.adult_price > 0) {
          adult_P = item.adult_price * adultTraveler;
        }
        let infant_P = 0;
        if (item.infant_price > 0) {
          infant_P = item.infant_price * infantTraveler;
        }
        let child_P = 0;
        if (item.child_price > 0) {
          child_P = item.child_price * childTraveler;
        }
        let youth_P = 0;
        if (item.youth_price > 0) {
          youth_P = item.youth_price * youthTraveler;
        }
        let senior_P = 0;
        if (item.senior_price > 0) {
          senior_P = item.senior_price * seniorTraveler;
        }

        total = adult_P + infant_P + child_P + youth_P + senior_P;

        if (i.specialOffer != "no_offer") {
          let result = [];

          i.specialOffer.map((l, j) => {
            if (l.combineoffer == "nocombine") {
              if (l.specialdata.discount_id == 2) {
                const disA = l.specialdata.rate_amount;
                result.push(+disA);
              } else {
                const disA = total - l.specialdata.rate_amount;
                result.push(+disA);
              }
            } else {
              if (l.specialdata.discount_id == 2) {
                const disA = l.specialdata.rate_amount;
                result.push(+disA);
              } else {
                const disA = total - l.specialdata.rate_amount;
                result.push(+disA);
              }
            }
          });

          const Amount = result.reduce((a, v) => a + v * 1, 0).toFixed(2);
          const $UpliftAmountTotal =
            (parseInt(i.priceuplift[0]) / 100) * total;
          const UpliftGroupTotal = parseInt(total) + $UpliftAmountTotal;
          const balanceAmount =
            UpliftGroupTotal -
            (Math.round(Amount * UpliftGroupTotal) / 100).toFixed(2);

          TPrice = balanceAmount;
        } else {
          const $UpliftAmountTotal =
            (parseInt(i.priceuplift[0]) / 100) * total;
          const UpliftGroupAmount = parseInt(total) + $UpliftAmountTotal;
          TPrice = UpliftGroupAmount;
          // TPrice = total;
        }

        // TPrice = total;
      } else {
        if (index == 0) {
          let adultTraveler = carts.reduce(
            (a, v) => a + v.adultCounter * 1,
            0
          );
          let infantTraveler = carts.reduce(
            (a, v) => a + v.infantCounter * 1,
            0
          );
          let childTraveler = carts.reduce(
            (a, v) => a + v.childCounter * 1,
            0
          );
          let youthTraveler = carts.reduce(
            (a, v) => a + v.youthCounter * 1,
            0
          );
          let seniorTraveler = carts.reduce(
            (a, v) => a + v.seniorCounter * 1,
            0
          );

          Traveller =
            adultTraveler * 1 +
            infantTraveler * 1 +
            childTraveler * 1 +
            youthTraveler * 1 +
            seniorTraveler * 1;

          let adult_P = 0;
          if (adultTraveler > 0) {
            let AdultTo = i.price[0].filter(
              (i) =>
                adultTraveler <= i.adult_max && adultTraveler >= i.adult_min
            );

            if (AdultTo.length > 0) {
              adult_P = AdultTo[0].adult_price * adultTraveler;
            }
          }
          let infant_P = 0;
          if (infantTraveler > 0) {
            let infantTo = i.price[0].filter(
              (i) =>
                infantTraveler <= i.infant_max &&
                infantTraveler >= i.infant_min
            );

            if (infantTo.length > 0) {
              infant_P = infantTo[0].infant_price * infantTraveler;
            }
          }
          let child_P = 0;
          if (childTraveler > 0) {
            let childTo = i.price[0].filter(
              (i) =>
                childTraveler <= i.child_max && childTraveler >= i.child_min
            );

            if (childTo.length > 0) {
              child_P = childTo[0].child_price * childTraveler;
            }
          }
          let youth_P = 0;
          if (youthTraveler > 0) {
            let youthTo = i.price[0].filter(
              (i) =>
                youthTraveler <= i.youth_max && youthTraveler >= i.youth_min
            );

            if (youthTo.length > 0) {
              youth_P = youthTo[0].youth_price * youthTraveler;
            }
          }

          let senior_P = 0;
          if (seniorTraveler > 0) {
            let seniorTo = i.price[0].filter(
              (i) =>
                seniorTraveler <= i.senior_max &&
                seniorTraveler >= i.senior_min
            );

            if (seniorTo.length > 0) {
              senior_P = seniorTo[0].senior_price * seniorTraveler;
            }
          }

          total =
            adult_P * 1 +
            infant_P * 1 +
            child_P * 1 +
            youth_P * 1 +
            senior_P * 1;

          if (total != 0) {
            if (i.specialOffer != "no_offer") {
              let result = [];

              i.specialOffer.map((l, j) => {
                if (l.combineoffer == "nocombine") {
                  if (l.specialdata.discount_id == 2) {
                    const disA = l.specialdata.rate_amount;
                    result.push(+disA);
                  } else {
                    const disA = total - l.specialdata.rate_amount;
                    result.push(+disA);
                  }
                } else {
                  if (l.specialdata.discount_id == 2) {
                    const disA = l.specialdata.rate_amount;
                    result.push(+disA);
                  } else {
                    const disA = total - l.specialdata.rate_amount;
                    result.push(+disA);
                  }
                }
              });

              const Amount = result.reduce((a, v) => a + v * 1, 0).toFixed(2);

              const $UpliftAmountTotal =
                (parseInt(i.priceuplift[0]) / 100) * total;
              const UpliftGroupTotal = parseInt(total) + $UpliftAmountTotal;

              const balanceAmount =
                UpliftGroupTotal -
                (Math.round(Amount * UpliftGroupTotal) / 100).toFixed(2);

              TPrice = balanceAmount;
            } else {
              const $UpliftAmountTotal =
                (parseInt(i.priceuplift[0]) / 100) * total;
              const UpliftGroupTotal = parseInt(total) + $UpliftAmountTotal;
              TPrice = UpliftGroupTotal;
            }

            //return total;
          }
        }
      }
    }
  });
 
  let travellerNew = "";
 // const CartDatanew = this.props.showcart.cardItems.cardData;
  const CartDatanew = selectedData;
  if (CartDatanew[0]) {
    const filteredAttraction = Object.entries(CartDatanew).filter((obj) => {
      return obj[1].profileactivity === "Transfers";
    });

    const filteredrateplan_id = Object.entries(CartDatanew).filter((obj) => {
      return obj[1].ratePlanId === ratePlanId;
    });

    if (filteredAttraction) {
      //Check Type
      if (filteredrateplan_id.length > 0) {
        const arrayData = filteredrateplan_id.pop();
        travellerNew =
          (arrayData[1].traveller != "undefined"
            ? arrayData[1].traveller
            : Traveller) + Traveller;
      } else {
        travellerNew = Traveller;
      }
    }
  } else {
    travellerNew = Traveller;
  }

  let TotalCountTravellerNew = travellerNew;
  let totaltax = (Math.round(extracharges * TPrice) / 100).toFixed(2);
  let TotalAmount = (TPrice+parseInt(totaltax)).toFixed(2);
  let taxamount = parseInt(totaltax);
  let offer_Percentage = OfferAn?.rateDiscount===''?0:parseInt(OfferAn?.rateDiscount).toFixed(2);
 // console.log(offer_Percentage);
  let Percentage = isNaN(offer_Percentage) ? 0 : parseInt(offer_Percentage); // 0offer_Percentage===NaN?0:offer_Percentage;
 // console.log(Percentage);
  let Selling_Price = (100/(100-parseInt(Percentage))*TotalAmount)
  let PercentageAm = parseInt(Selling_Price+TotalAmount).toFixed(2);
  var newDatareduxShow = {
    tour_id: tour_id,
    dateselected: selectedDate,
    tourImage: galleryimage,
    number: selectedForTime,
    ratePlanId: ratePlanId,
    numberTraveler: numberTraveler,
    tourName: tour_name,
    tourOption: option_name,
    tourLocation: tour_location,
    time: time,
    price_type: price_type,
    tour_operator_id: tour_operator_id,
    profileactivity: "TransfersFerry",
    overview: i.tour_overview,
    price: TPrice,
    percentageAm: PercentageAm,
    percentage: Percentage,
    totalAmount: Selling_Price,
    taxfeeepercent: extracharges,
    totalamountincluded: TotalAmount,
    taxamount: taxamount,
    transfertype: "",
    isChecked: "",
    traveller: TotalCountTravellerNew,
    availability: i.availability,
    OfferName: OfferAn,
    cancellationpolicy: cancellationpolicy,
    firstcancellationdate:firstcancellationdate,
    paylater:paylater,
    serviceDate: selectedDate
  };

  let newData = { traveller: Traveller };

 

  if (TotalCountTravellerNew > i.availability) {
    // this.setState((prevState) => ({
    //   cartcheckAvailability: [...prevState.cartcheckAvailability, newData],
    // }));
    setcartcheckAvailability([...cartcheckAvailability, newData]);
    alert("No Availability Found!");
  } else {
    // this.setState((prevState) => ({
    //   cartcheckAvailability: [...prevState.cartcheckAvailability, newData],
    // }));
    setcartcheckAvailability([...cartcheckAvailability, newData]);
    if (CartIndexNumber != null) {
      // const CartData = selectedData;
      // let CartItems = [...CartData];

      // CartItems.splice(this.state.CartIndexNumber, 1);
      // CartItems.splice(this.state.CartIndexNumber, 0, newDatareduxShow);


      const CartData = selectedData;
      let CartItems = [...CartData];

      CartItems.splice(CartIndexNumber, 1);
      CartItems.splice(CartIndexNumber, 0, newDatareduxShow);

    
     dispatch(clearToCart(CartItems));
     dispatch(updateToCart(CartItems));
      //  setTimeout(() => {
      //   this.props.updateToCart(CartItems);
      //  }, 1000);
    } else {
     // this.props.addToCart(newDatareduxShow);
     dispatch(addToCart(newDatareduxShow));
    }
    localStorage.setItem('transferFerrySlide', false);
    // setTimeout(() => {
    //   window.location.reload(true);
    //  }, 1000);
  }
};


//  function SortingFunction(data){
//   if (data != "no_activity") {

//     const sorArr = data;
//     setTimeout(() => {


//       setactivityData(sorArr);
      
//         setactivityListFilter(sorArr);
//         settotalactivityData(sorArr);
   
//         setSkeletonData(false)
     
//     }, 1000);
//   }
// };


  let backListingPage = () => {
    setopenAttractionDetails("ACCL");
  };

  let detailsPageData = (tourid, dateSelected, countDetails) => {
    setopenAttractionDetails("ACCD");
    settourIDDetails(tourid);
   setselectActivityDayDetails(moment(new Date(dateSelected)).format("dddd, MMM D, YYYY"));
    setselectActivityDayNewDetails(moment(dateSelected).format("Y-MM-DD"));
  };
  useEffect(() => {
    if(tourIDDetails){
      settourdataDetails("");
      setshow_options(false);
      setnumberTraveler("Number of travelers");
    let JsonState = {
      tourid: tourIDDetails,
      dateSelected:selectActivityDayNewDetails,
    };
    const  dateSelectednew = selectActivityDayNewDetails;
      setselectActivityDayDetails(moment(new Date(dateSelectednew)).format("dddd, MMM D, YYYY"));
      setselectActivityDayNewDetails(moment(dateSelectednew).format("Y-MM-DD"));
    const experienceDetails = JSON.stringify(JsonState);
    TransferDetailsData(experienceDetails).then(
      (data) => {
        data.map((i, j) => {
          //console.log(i);
          if (i?.extracharges == "no_extracharge") {
            settourExtrachargesDetails(0);
          } else {
            settourExtrachargesDetails(i.extracharges);
          }
          settourdataDetails(i?.tour_data);
          settourDescriptionDetails(i?.tour_description);
          settourPriceDetails(i?.tour_price);
          settourInclusionDetails(i?.tour_inclusion);
          settourExclusionDetails(i?.tour_exclusion);
          settourMeetingpointDetails(i?.tour_meetingpoint);
          settourCancellationPolicyDetails(i?.tour_cancellation_policy);
          settourFreeCancellationPolicyDetails(i?.freeroomCancellation);
          //settourItineraryDetails(i?.tour_itinerary);
          settourTransportDetails(i?.tour_transport);
          settourSingleTourGalleryDetails(i?.tour_gallery[0]);
          const newGallery = [];
          i.tour_gallery.map((x, y) => {
            newGallery.push({ original: x, thumbnail: x });
          });
          settourGalleryDetails(newGallery);

           /// Start Transfer Data 
          //  if (numberTraveler == "Number of travelers") {
            let adultTraveler = carts.reduce((a, v) => a + v.adultCounter * 1, 0);
            let infantTraveler = carts.reduce((a, v) => a + v.infantCounter * 1, 0);
            let childTraveler = carts.reduce((a, v) => a + v.childCounter * 1, 0);
            let youthTraveler = carts.reduce((a, v) => a + v.youthCounter * 1, 0);
            let seniorTraveler = carts.reduce((a, v) => a + v.seniorCounter * 1, 0);
            let GroupTraveler = carts.reduce((a, v) => a + v.groupCounter * 1, 0);
      
            let newString = "";
            if (i?.tour_price?.price_options?.adult == 1) {
              if (adultTraveler == 1) {
                newString = adultTraveler + " adult";
              } else {
                newString = adultTraveler + " adults";
              }
            }
      
            if (i?.tour_price?.price_options?.child == 1) {
              if (childTraveler > 0) {
                if (childTraveler == 1) {
                  newString = newString + ", " + childTraveler + " child";
                } else {
                  newString = newString + ", " + childTraveler + "children";
                }
              }
            }
      
            if (i?.tour_price?.price_options?.infant == 1) {
              if (infantTraveler > 0) {
                if (infantTraveler == 1) {
                  newString = newString + ", " + infantTraveler + " infant";
                } else {
                  newString = newString + ", " + infantTraveler + " infants";
                }
              }
            }
      
            if (i?.tour_price?.price_options?.youth == 1) {
              if (youthTraveler > 0) {
                if (youthTraveler == 1) {
                  newString = newString + ", " + youthTraveler + " youth";
                } else {
                  newString = newString + ", " + youthTraveler + " youths";
                }
              }
            }
      
            if (i?.tour_price?.price_options?.senior == 1) {
              if (seniorTraveler > 0) {
                if (seniorTraveler == 1) {
                  newString = newString + seniorTraveler + " senior";
                } else {
                  newString = newString + seniorTraveler + " seniors";
                }
              }
            }
      
            if (i?.tour_price?.price_options.price_plan == 2) {
              if (i?.tour_price?.price_options.max_booking_travelers_free > 0) {
                newString = GroupTraveler + " free travelers";
              }
            } else {
              if (i?.tour_price?.tour_price_data.group_max > 0) {
                newString = GroupTraveler + " travelers";
              }
            }
      
            setnumberTraveler(newString);
          //}   
        // End Transfer Data

        });
      },
      (error) => {
        setError(error);
      }
    );

  
    }

  },[tourIDDetails]);


  let openAccomodationFacilityGalary = () => {
    setopenAttractionDetails("ACCF");
  };
  let backAccomodationDetails = () => {
    setopenAttractionDetails("ACCD");
  };
  const showSorting = (syntheticEvent) => {
    
    syntheticEvent.stopPropagation();
    setsorting(true);
   
  };
  const handleSortingChange = (e) => {
   
    settransferData(null);
     setSkeletonData(true);
    const sorArr = transferData;
    if (e.id == 2) {
      setTimeout(() => {
        const getValue = (price) => -price;
        sorArr.sort(
          (a, b) =>
            getValue(
              Object.values(a).map((i, j) => {
                return i.tour_price;
              })
            ) -
            getValue(
              Object.values(b).map((i, j) => {
                return i.tour_price;
              })
            )
        );

        settransferData(sorArr);
        setSkeletonData(false);
      }, 2000);
    } else if (e.id == 3) {
      setTimeout(() => {
        const getValue = (star) => -star;
        sorArr.sort((a, b) => getValue() - getValue());

        settransferData(sorArr);
        setSkeletonData(false);
      }, 2000);
    } else if (e.id == 1) {
      setTimeout(() => {
        const getValue = (price) => +price;
        sorArr.sort(
          (a, b) =>
            getValue(
              Object.values(a).map((i, j) => {
                return i.tour_price;
              })
            ) -
            getValue(
              Object.values(b).map((i, j) => {
                return i.tour_price;
              })
            )
        );

        settransferData(sorArr);
        setSkeletonData(false);
      }, 2000);
    } else if (e.id == 4) {
      setTimeout(() => {
        const getValue = (id) => id;
        sorArr.sort(
          (a, b) =>
            getValue(
              Object.values(a).map((i, j) => {
                return i.tour_data.id;
              })
            ) -
            getValue(
              Object.values(b).map((i, j) => {
                return i.tour_data.id;
              })
            )
        );

        settransferData(sorArr);
        setSkeletonData(false);
      }, 2000);
    }

    setsortingSelectTour(e.name);
    setsortingIdTour(e.id);
    setsorting(false);
  };
 
  const onMouseOutFun = (image) => {
    setImageChanger(image);
  };
  const onMouseOverFun = (image) => {
    setImageChanger(image);
  };


  const getAmount = (data, forMeal, Price) => {
    const data12 = Object.entries(forMeal);
    const rateId = data12.filter(([key, value]) => value == Price);

    const Offer1 = data.filter(
      (item, key) =>
        item != "no_offer" && item.tourSpecial.rate_plan_id == rateId[0][0]
    );

    if (Offer1.length > 0) {
      let result = [];

      Offer1.map((i, j) => {
        if (i.combineoffer == "nocombine") {
          if (i.specialdata.discount_id == 2) {
            const disA = i.specialdata.rate_amount;
            result.push(+disA);
          } else {
            const disA = Price - i.specialdata.rate_amount;
            result.push(+disA);
          }
        } else {
          if (i.specialdata.discount_id == 2) {
            const disA = i.specialdata.rate_amount;
            result.push(+disA);
          } else {
            const disA = Price - i.specialdata.rate_amount;
            result.push(+disA);
          }
        }
      });

      const Amount = result.reduce((a, v) => a + v, 0);

      const balanceAmount =
        Price - (Math.round(Amount * Price) / 100).toFixed(2);
      return (
        <>
          <div className="listingPrice">
          <p
            className="grayText font16 lineThrough appendBottom5 appendRight5"
            id="hlistpg_hotel_cut_price"
          >
            <span>€</span>
            {Price.toFixed(2)}
          </p>
          {/* <p>
            <span className="font-weight-bold text-lowercase from-price-text">
              From{" "}
            </span>
          </p> */}
          <p
            className="latoBlack font16 blackText appendBottom5"
            id="hlistpg_hotel_shown_price"
          >
            <span>€</span>
            {balanceAmount.toFixed(2)}
          </p>
          </div>
          <p class="makeFlex hrtlCenter right appendBottom10 directionRtl">
            <span class="redText font12">
              <span>Save </span>
              <span class="latoBold" id="hlistpg_hotel_saved_price">
                <span>€</span>
                {(Math.round(Amount * Price) / 100).toFixed(2)}
              </span>
            </span>
            <span class="spriteNew discountIcon relative appendLeft5">
              <span
                class="latoBold font11 whiteText discountText"
                id="hlistpg_hotel_saved_price_percentage"
                style={{
                  lineHeight: "15px",
                  paddingRight: "5px",
                }}
              >
                {parseInt(Amount)}%
              </span>
            </span>
          </p>
        </>
      );
    } else {
      return (
        <>
          {/* <p>
            <span className="font-weight-bold text-lowercase from-price-text">
              From{" "}
            </span>
          </p> */}
          <p
            className="latoBlack font16 blackText appendBottom5"
            id="hlistpg_hotel_shown_price"
          >
            <span>€</span>
            {Price.toFixed(2)}
          </p>
        </>
      );
    }
  };


  const getDetailsAmount = (data, price) => {
   // console.log(data);
    let result = [];

    if (data?.combineoffer == "nocombine") {
      if (data.specialdata.discount_id == 2) {
        const disA = data.specialdata.rate_amount;
        result.push(+disA);
      } else {
        const disA = price - data.specialdata.rate_amount;
        result.push(+disA);
      }
    } else {
      if (data.specialdata.discount_id == 2) {
        const disA = data.specialdata.rate_amount;
        result.push(+disA);
      } else {
        const disA = price - data.specialdata.rate_amount;
        result.push(+disA);
      }
    }

    const Amount = result.reduce((a, v) => a + v * 1, 0).toFixed(2);

    const balanceAmount = price - (Math.round(Amount * price) / 100).toFixed(2);

    return (
      <>
        <p
          class="makeFlex hrtlCenter right appendBottom10 directionRtl"
          style={{ textAlign: "end" }}
        >
          <span class="redText font12">
            <span>Save </span>
            <span class="latoBold" id="hlistpg_hotel_saved_price">
              <span>€</span>
              {((Amount * price) / 100).toFixed(2)}
            </span>
          </span>
          <span class="spriteNew discountIcon relative appendLeft5">
            <span
              class="latoBold font11 whiteText discountText"
              id="hlistpg_hotel_saved_price_percentage"
              style={{
                lineHeight: "15px",
                paddingRight: "5px",
              }}
            >
              {parseInt(Amount)}%
            </span>
          </span>
        </p>
        <p
          className="grayText font16 lineThrough appendBottom5"
          id="hlistpg_hotel_cut_price"
        >
          <span>€</span>
          {price}
        </p>
        <p
          className="latoBlack font16 blackText appendBottom5"
          id="hlistpg_hotel_shown_price"
        >
          <span>€</span>
          {balanceAmount.toFixed(2)}
        </p>
      </>
    );
  };

  const checkinandcheckoutActivity = ()=> {
    setcheckinShowActivity(true);
    // syntheticEvent.stopPropagation();
    // this.setState(
    //   (prevSta: ! }),
    //   () => {
    //     if (t) {
    //       // document.addEventListener('click', this.globalClickListener)
    //       window.addEventListener("click", this.globalClickListener);
    //     }
    //   }
    // );
  };
  // const handleActivityDayClick = (day) => {
  //   console.log(day);
  //   setselectActivityDayNewDetails(day);
  //   setselectActivityDayDetails(moment(day).format("dddd, MMM D, YYYY"))(false);
  // };
  const  handleActivityDayClick = (day) => {
    setselectActivityDayNew(day);
    setselectActivityDayDetails(moment(day).format("dddd, MMM D, YYYY"));
    // this.setState({
    //   selectActivityDay: moment(day).format("dddd, MMM D, YYYY"),
    // });
    setcheckinShowActivity(false);
    setdropdownVisible(false);
  };
  const handleBodyClick = (event) => {
    //event.stopPropagation();
    setdropdownVisible(false);
        // showResults: false,
        // checkinShow: false,
        // showResultsActivity: false,
        // checkinShowActivity: false,
        // showResultsPackage: false,
        // checkinShowPackage: false,
        // showResultsTransfer: false,
        // checkinShowTransfer: false,
  };

  const toggleDropdown = (syntheticEvent) => {
    setdropdownVisible(true);
    // syntheticEvent.stopPropagation();
    // this.setState(
    //   (prevState) => ({ dropdownVisible: !prevState.dropdownVisible }),
    //   () => {
    //     if (dropdownVisible) {
    //       // document.addEventListener('click', this.globalClickListener)
    //       window.addEventListener("click", this.globalClickListener);
    //     }
    

    scrollToRef(myDivToFocus);
  };

  const menuclassName = `panel-dropdown${
    dropdownVisible ? " active" : ""
  }`;


  const setApplyTraveler = () => {
    let adultTraveler = carts.reduce(
      (a, v) => a + v.adultCounter * 1,
      0
    );
    let infantTraveler = carts.reduce(
      (a, v) => a + v.infantCounter * 1,
      0
    );
    let childTraveler = carts.reduce(
      (a, v) => a + v.childCounter * 1,
      0
    );
    let youthTraveler = carts.reduce(
      (a, v) => a + v.youthCounter * 1,
      0
    );
    let seniorTraveler = carts.reduce(
      (a, v) => a + v.seniorCounter * 1,
      0
    );
    let GroupTraveler = carts.reduce(
      (a, v) => a + v.groupCounter * 1,
      0
    );

    let newString = "";
    if (tourPriceDetails.price_options.adult == 1) {
      if (adultTraveler == 1) {
        newString = adultTraveler + " adult";
      } else {
        newString = adultTraveler + " adults";
      }
    }

    if (tourPriceDetails.price_options.child == 1) {
      if (childTraveler > 0) {
        if (childTraveler == 1) {
          newString = newString + ", " + childTraveler + " child";
        } else {
          newString = newString + ", " + childTraveler + "children";
        }
      }
    }

    if (tourPriceDetails.price_options.infant == 1) {
      if (infantTraveler > 0) {
        if (infantTraveler == 1) {
          newString = newString + ", " + infantTraveler + " infant";
        } else {
          newString = newString + ", " + infantTraveler + " infants";
        }
      }
    }

    if (tourPriceDetails.price_options.youth == 1) {
      if (youthTraveler > 0) {
        if (youthTraveler == 1) {
          newString = newString + ", " + youthTraveler + " youth";
        } else {
          newString = newString + ", " + youthTraveler + " youths";
        }
      }
    }

    if (tourPriceDetails.price_options.senior == 1) {
      if (seniorTraveler > 0) {
        if (seniorTraveler == 1) {
          newString = newString + ", " + seniorTraveler + " senior";
        } else {
          newString = newString + ", " + seniorTraveler + " seniors";
        }
      }
    }

    // if (tourPriceDetails.tour_price_data.group_max > 0) {
    //   newString = GroupTraveler + " travelers";
    // }
    if (tourPriceDetails.price_options.price_plan == 2) {
      if (tourPriceDetails.price_options.max_booking_travelers_free > 0) {
        newString = GroupTraveler + " free travelers";
      }
    } else {
      if (tourPriceDetails.tour_price_data.group_max > 0) {
        newString = GroupTraveler + " travelers";
      }
    }
    setnumberTraveler(newString);
    setdropdownVisible(false);
    //this.setState({ numberTraveler: newString, dropdownVisible: false });

    setshow_options(true);
    settour_options(null);
    setcheckName("Update Search");

    setselectedIndex(null);
    setselectedIndexNew(null);
    setbuttonDisabled("disabled");

    let numberTravelers = carts;
    let checkDate = moment(selectActivityDayNewDetails).format("Y-MM-DD");
    let tour_id = tourdataDetails.id;
    let price_type = tourPriceDetails.price_options.price_type;

    CheckAvailabilityData(numberTravelers, checkDate, tour_id, price_type).then(
      (data) => {
        settour_options(data);
      },
      (error) => {
        setError(error);
      }
    );

   
  };
  const renderDropdownMenu = () => {
    return (
      <div className="roomsGuestsListNew">
        {carts.map((val, idx) => {
          return (
            <div className="roomsGuestsTop" key={idx}>
              {tourPriceDetails?.price_options?.price_plan == 1 ? (
                tourPriceDetails?.price_options?.price_type == 1 ? (
                  <div className="addRoomRowhs">
                    <div
                      className="addRoomLeft rowNew"
                      style={{ width: "100%" }}
                    >
                      <p
                        className={`${
                          errMessage == false
                            ? "darkText font16 appendBottom10"
                            : "darkText font16 appendBottom10 ErrM"
                        }`}
                        style={{ fontSize: 14 }}
                      >
                        You can select up to{" "}
                        {tourPriceDetails?.price_options.max_booking_travelers}{" "}
                        travelers in total.
                      </p>
                      <button
                        class="btn btn-secondary"
                        type="button"
                        onClick={setApplyTraveler}
                      >
                        Apply
                      </button>
                    </div>
                    <div className="addRoomRight">
                      <div className="addRooomDetails">
                        {tourPriceDetails?.price_options.adult == 1 && (
                          <div>
                            <p className="spaceBetween appendBottom10">
                              <span className="latoBold font12 grayText">
                                Adult (age{" "}
                                {tourPriceDetails?.price_options?.adult_min}-
                                {tourPriceDetails?.price_options?.adult_max}){" "}
                              </span>
                            </p>
                            <ul
                              className="guestCounter font12 darkText"
                              style={{ width: 370 }}
                            >
                              {ListNumber.map((item, index) => {
                                return index <
                                  tourPriceDetails?.price_options
                                    ?.max_booking_travelers ? (
                                  <li
                                    className={
                                      carts[idx]?.adultCounter == item.id
                                        ? "selected"
                                        : ""
                                    }
                                    key={index}
                                    onClick={() =>
                                      handleInputChange(
                                        item.id,
                                        idx,
                                        "adultCounter"
                                      )
                                    }
                                  >
                                    {item.id}
                                  </li>
                                ) : (
                                  <></>
                                );
                              })}
                            </ul>
                          </div>
                        )}

                        {tourPriceDetails.price_options.infant == 1 && (
                          <div>
                            <p className="spaceBetween appendBottom10">
                              <span className="latoBold font12 grayText">
                                Infant (age{" "}
                                {tourPriceDetails.price_options.infant_min}-
                                {tourPriceDetails.price_options.infant_max}){" "}
                              </span>
                            </p>
                            <ul
                              className="guestCounter font12 darkText"
                              style={{ width: 370 }}
                            >
                              {ListNumberNew.map((item, index) => {
                                return index <
                                  tourPriceDetails.price_options
                                    .max_booking_travelers ? (
                                  <li
                                    className={
                                      carts[idx].infantCounter == item.id
                                        ? "selected"
                                        : ""
                                    }
                                    key={index}
                                    onClick={() =>
                                      handleInputChange(
                                        item?.id,
                                        idx,
                                        "infantCounter"
                                      )
                                    }
                                  >
                                    {item.id}
                                  </li>
                                ) : (
                                  <></>
                                );
                              })}
                            </ul>
                          </div>
                        )}

                        {tourPriceDetails?.price_options.child == 1 && (
                          <div>
                            <p className="spaceBetween appendBottom10">
                              <span className="latoBold font12 grayText">
                                Child (age{" "}
                                {tourPriceDetails.price_options.child_min}-
                                {tourPriceDetails.price_options.child_max}){" "}
                              </span>
                            </p>
                            <ul
                              className="guestCounter font12 darkText"
                              style={{ width: 370 }}
                            >
                              {ListNumberNew.map((item, index) => {
                                return index <
                                  tourPriceDetails.price_options
                                    .max_booking_travelers ? (
                                  <li
                                    className={
                                      carts[idx].childCounter == item.id
                                        ? "selected"
                                        : ""
                                    }
                                    key={index}
                                    onClick={() =>
                                      handleInputChange(
                                        item?.id,
                                        idx,
                                        "childCounter"
                                      )
                                    }
                                  >
                                    {item.id}
                                  </li>
                                ) : (
                                  <></>
                                );
                              })}
                            </ul>
                          </div>
                        )}

                        {tourPriceDetails?.price_options?.youth == 1 && (
                          <div>
                            <p className="spaceBetween appendBottom10">
                              <span className="latoBold font12 grayText">
                                Youth (age{" "}
                                {tourPriceDetails?.price_options?.youth_min}-
                                {tourPriceDetails.price_options?.youth_max}){" "}
                              </span>
                            </p>
                            <ul
                              className="guestCounter font12 darkText"
                              style={{ width: 370 }}
                            >
                              {ListNumberNew.map((item, index) => {
                                return index <
                                  tourPriceDetails?.price_options
                                    ?.max_booking_travelers ? (
                                  <li
                                    className={
                                      carts[idx].youthCounter == item.id
                                        ? "selected"
                                        : ""
                                    }
                                    key={index}
                                    onClick={() =>
                                      handleInputChange(
                                        item?.id,
                                        idx,
                                        "youthCounter"
                                      )
                                    }
                                  >
                                    {item.id}
                                  </li>
                                ) : (
                                  <></>
                                );
                              })}
                            </ul>
                          </div>
                        )}

                        {tourPriceDetails?.price_options?.senior == 1 && (
                          <div>
                            <p className="spaceBetween appendBottom10">
                              <span className="latoBold font12 grayText">
                                Senior (age{" "}
                                {tourPriceDetails?.price_options?.senior_min}-
                                {tourPriceDetails?.price_options?.senior_max}){" "}
                              </span>
                            </p>
                            <ul
                              className="guestCounter font12 darkText"
                              style={{ width: 370 }}
                            >
                              {ListNumberNew.map((item, index) => {
                                return index <
                                  tourPriceDetails?.price_options
                                    .max_booking_travelers ? (
                                  <li
                                    className={
                                      carts[idx].seniorCounter == item.id
                                        ? "selected"
                                        : ""
                                    }
                                    key={index}
                                    onClick={() =>
                                      handleInputChange(
                                        item?.id,
                                        idx,
                                        "seniorCounter"
                                      )
                                    }
                                  >
                                    {item.id}
                                  </li>
                                ) : (
                                  <></>
                                );
                              })}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="addRoomRowhs">
                    <div
                      className="addRoomLeft rowNew"
                      style={{ width: "100%" }}
                    >
                      <p
                        className="darkText font16 appendBottom10"
                        style={{ fontSize: 14 }}
                      >
                        You can select up to{" "}
                        {tourPriceDetails?.tour_price_data?.group_max} travelers
                        in total.
                      </p>
                      <button
                        class="btn btn-secondary"
                        type="button"
                        onClick={setApplyTraveler}
                      >
                        Apply
                      </button>
                    </div>
                    <div className="addRoomRight">
                      <div className="addRooomDetails">
                        <p className="spaceBetween appendBottom10">
                          <span className="latoBold font12 grayText">
                            Number of travelers
                          </span>
                        </p>
                        <ul
                          className="guestCounter font12 darkText"
                          style={{ width: 370 }}
                        >
                          {ListNumber.map((item, index) =>
                            index <
                            tourPriceDetails?.tour_price_data?.group_max ? (
                              <li
                                className={
                                  carts[idx]?.groupCounter == item.id
                                    ? "selected"
                                    : ""
                                }
                                key={index}
                                onClick={() =>
                                  handleInputChangeNew(
                                    item?.id,
                                    idx,
                                    "groupCounter"
                                  )
                                }
                              >
                                {item.id}
                              </li>
                            ) : (
                              <></>
                            )
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                )
              ) : (
                <div className="addRoomRowhs">
                  <div className="addRoomLeft rowNew" style={{ width: "100%" }}>
                    <p
                      className="darkText font16 appendBottom10"
                      style={{ fontSize: 14 }}
                    >
                      You can select up to{" "}
                      {
                        tourPriceDetails?.price_options
                          ?.max_booking_travelers_free
                      }{" "}
                      travelers in total.
                    </p>
                    <button
                      class="btn btn-secondary"
                      type="button"
                      onClick={setApplyTraveler}
                    >
                      Apply
                    </button>
                  </div>
                  <div className="addRoomRight">
                    <div className="addRooomDetails">
                      <p className="spaceBetween appendBottom10">
                        <span className="latoBold font12 grayText">
                          Number of travelers
                        </span>
                      </p>
                      <ul
                        className="guestCounter font12 darkText"
                        style={{ width: 370 }}
                      >
                        {ListNumber.map((item, index) =>
                          index <
                          tourPriceDetails?.price_options
                            ?.max_booking_travelers_free ? (
                            <li
                              className={
                                carts[idx]?.groupCounter == item.id
                                  ? "selected"
                                  : ""
                              }
                              key={index}
                              onClick={() =>
                                handleInputChangeNew(
                                  item?.id,
                                  idx,
                                  "groupCounter"
                                )
                              }
                            >
                              {item.id}
                            </li>
                          ) : (
                            <></>
                          )
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const CheckAvailability = () => {
    setshow_options(true);
    settour_options(null);
    setdropdownVisible(true);
    setcheckName("Update Search");

    setselectedIndex(null);
    setselectedIndexNew(null);
    setbuttonDisabled("disabled");
    if (numberTraveler == "Number of travelers") {
      let adultTraveler = carts.reduce(
        (a, v) => a + v.adultCounter * 1,
        0
      );
      let infantTraveler = carts.reduce(
        (a, v) => a + v.infantCounter * 1,
        0
      );
      let childTraveler = carts.reduce(
        (a, v) => a + v.childCounter * 1,
        0
      );
      let youthTraveler = carts.reduce(
        (a, v) => a + v.youthCounter * 1,
        0
      );
      let seniorTraveler = carts.reduce(
        (a, v) => a + v.seniorCounter * 1,
        0
      );
      let GroupTraveler = carts.reduce(
        (a, v) => a + v.groupCounter * 1,
        0
      );

      let newString = "";
      if (tourPriceDetails?.price_options?.adult == 1) {
        if (adultTraveler == 1) {
          newString = adultTraveler + " adult";
        } else {
          newString = adultTraveler + " adults";
        }
      }

      if (tourPriceDetails?.price_options?.child == 1) {
        if (childTraveler > 0) {
          if (childTraveler == 1) {
            newString = newString + ", " + childTraveler + " child";
          } else {
            newString = newString + ", " + childTraveler + "children";
          }
        }
      }

      if (tourPriceDetails?.price_options?.infant == 1) {
        if (infantTraveler > 0) {
          if (infantTraveler == 1) {
            newString = newString + ", " + infantTraveler + " infant";
          } else {
            newString = newString + ", " + infantTraveler + " infants";
          }
        }
      }

      if (tourPriceDetails?.price_options?.youth == 1) {
        if (youthTraveler > 0) {
          if (youthTraveler == 1) {
            newString = newString + ", " + youthTraveler + " youth";
          } else {
            newString = newString + ", " + youthTraveler + " youths";
          }
        }
      }

      if (tourPriceDetails?.price_options?.senior == 1) {
        if (seniorTraveler > 0) {
          if (seniorTraveler == 1) {
            newString = newString + seniorTraveler + " senior";
          } else {
            newString = newString + seniorTraveler + " seniors";
          }
        }
      }

      // if (tourPriceDetails?.tour_price_data?.group_max > 0) {
      //   newString = GroupTraveler + " travelers";
      // }
      if (tourPriceDetails?.price_options.price_plan == 2) {
        if (tourPriceDetails?.price_options.max_booking_travelers_free > 0) {
          newString = GroupTraveler + " free travelers";
        }
      } else {
        if (tourPriceDetails?.tour_price_data.group_max > 0) {
          newString = GroupTraveler + " travelers";
        }
      }
      setnumberTraveler(newString);
      setdropdownVisible(true);
    //  this.setState({ numberTraveler: newString, dropdownVisible: true });
     scrollToRef(myDivToFocus);
    }
    let numberTravelers = carts;
    let checkDate = moment(selectActivityDayNewDetails).format("Y-MM-DD");
    let tour_id = tourdataDetails?.id;
    let price_type = tourPriceDetails?.price_options?.price_type;

    CheckAvailabilityData(numberTravelers, checkDate, tour_id, price_type).then(
      (data) => {
        settour_options(data);
      },
      (error) => {
        
        setError(error)
      }
    );
  };



 const handleInputChange = (e, index, counter) => {
  
    let cart = [...carts];
    cart[index][counter] = e;
    console.log(cart);
    setcarts(cart);
   
    const sumTraveler = carts.reduce(
      (a, v) =>
        a +
        v.adultCounter * 1 +
        v.infantCounter * 1 +
        v.childCounter * 1 +
        v.youthCounter * 1 +
        v.seniorCounter * 1,
      0
    );
     // alert(sumTraveler);
    const maxTraveler = tourPriceDetails.price_options
      .max_booking_travelers;
    if (sumTraveler > maxTraveler) {
      seterrMessage(true);
      if (counter == "adultCounter") {
        let cart = [...carts];
        cart[index][counter] = 1;
        setcarts(cart);
        // this.setState({
        //   cats: cats,
        // });
      } else {
        let cart = [...carts];
        cart[index][counter] = 0;
        // this.setState({
        //   cats: cats,
        // });
        setcarts(cart);
      }
      setTimeout(() => {
        // this.setState({ errMessage: false });
        seterrMessage(false);
      }, 5000);
    }
    setdropdownVisible(true);
  };

 const handleInputChangeNew = (e, index, counter) => {
    let cart = [...carts];
    cart[index][counter] = e;
    setcarts(cart);
    setdropdownVisible(true);
  };


  const setTimeSelected = (item, index, j) => {
    setselectedIndex(j + "_" + index);
    setselectedIndexNew(j);
    setselectedTime(index + 1);
    setselectedTimeValue(item.from_time);
    //this.setState({ buttonDisabled: '' });
  };

  let CancellationModal = (data) => {
    let DataNew = "";
    let Value = "";
    let EuroIcon = "";
    let PerIcon = "";
    let ContentData = "";
    return (
      <>
        {" "}
        {data
          .slice(0)
          .reverse()
          .map((i, index) => {
            //const date = new Date();
            const selectActivityDay = selectActivityDayDetails;
            const date = new Date(selectActivityDay);
            if (i.day_before_arrival == 1 || i.day_before_arrival == 2) {
              date.setDate(date.getDate() - i.day_before_arrival);
              DataNew = moment(date).format("Do MMM YYYY");
            }
            {
              date.setDate(date.getDate() - (i.day_before_arrival - 2));
              // DataNew = moment(date).format("Do MMM YYYY");
              DataNew =
                "If cancelled or modified " +
                parseInt(i.day_before_arrival - 2) +
                " days before date of experience (tour, event, attraction, activity).";
            }

            if (i.penalty == "No Penalty") {
              Value = 0;
              EuroIcon = "";
              PerIcon = "";
            } else if (i.penalty == "Full Amount") {
              Value = "";
              EuroIcon = "";
              PerIcon = "Full booking amount will be charged";
            } else if (i.penalty == "Percentage") {
              Value = i.cancellation_value;
              EuroIcon = "";
              PerIcon = "% of booking amount will be charged ";
            } else if (i.penalty == "Nights") {
              Value = i.cancellation_value;
              EuroIcon = EuroIcon = <span>€</span>;
              PerIcon = " amount will be charged.";
            } else if (i.penalty == "Fixed Amount") {
              Value = i.cancellation_value;
              EuroIcon = <span>€</span>;
              PerIcon = " amount will be charged.";
            }

            if (i.day_before_arrival == 1) {
              DataNew = "In case of no show";
              //ContentData = "In case of "
            }

            //   if (id == i.rate_plan_id) {
            return (
              <div className="cncpolicyTbl__row">
                <div className="cncpolicyTbl__col">
                  {index == 0 ? "" : ""} &#x202A;{DataNew}&#x202C;
                </div>
                <div className="cncpolicyTbl__col">
                  {EuroIcon} {Value}
                  {PerIcon}
                </div>
              </div>
            );
            //   }
          })}
      </>
    );
  };

  let getDateModal = (data) => {
    let DataNew = "";

    const selectActivityDay = selectActivityDayDetails;

    if (data[0].cancellation_penalty_id == 1) {
      const date = new Date(selectActivityDay);
      // date.setDate(date.getDate() - data[0].day_before_arrival);

      DataNew =
        "Free Cancellation (100% refund) if you cancel this booking on or before start of experience (tour, event, attraction, activity). ";
      // +moment(date).format("Do MMM YYYY");
    } else if (data[0].cancellation_penalty_id == 3) {
      DataNew =
        "Minimum " +
        data[0].cancellation_value +
        "% cancellation charges applicable";
    }

    return DataNew;
  };
  return (
    <div className="slider-container">
     
      <div className="modalContent activity">
        <div>
          <div className="theme-wrapper">
            {openAttractionDetails == "ACCD" ? (
              <>
               {tourdataDetails == "" ? (
                    <>
                       <DetailsSkeleton/>
                    </>
                  ):(
                <div className="sidePanelWrap" data-testid="activity-details">
                  <div className="sidePanelTopSection activityHeader">
                    <div className="makeFlex spaceBetween hrtlCenter">
                      <div className="viewDetailsHeading">
                        <span className="overlaySprite backArrowBlue activities"  onClick={() => backListingPage() }></span>
                        <span className="font20 blackText latoBlack viewDetailText">
                          Back to Listing
                        </span>
                      </div>
                    </div>
                  </div>
                  {tourdataDetails == "" ? (<></>):(<>
                 
                    {tourPriceDetails.price_options == "no_priceoption" ? (
              <>
                <div
                  className="Container-Tile-NoHotel"
                  style={{
                    height: " 350px",
                    width: "50%",
                    display: "contents",
                  }}
                >
                  <img
                    src={"images/no_transfer.png"}
                    style={{ margin: "0 auto", height: 250 }}
                  />
                  <h3
                    style={{
                      margin: "0 auto",
                      color: "#000",
                      fontSize: "32px",
                      fontWeight: "700",
                    }}
                  >
                    Sold Out!
                  </h3>
                  <p
                    class="font16 grayText appendTop10 appendBottom20"
                    style={{ margin: "8px auto" }}
                  >
                    {" "}
                    Sorry, all tours in area are sold out. Please change your
                    dates/ search criteria.
                  </p>
                </div>
              </>
            ) : (<>

                  <div className="activityDetailsSide">
                    <div className="appendBottom10 makeFlex hrtlCenter">
                      <h3 className="latoBlack font20 lineHeight26">
                     {tourdataDetails.tour_name}
                      </h3>
                      {/* <p className="ratng goodRating">
                        5
                        <span className="font10 latoRegular appendTop1">
                          /5
                        </span>
                      </p>{" "} */}
                    </div>
                    <div className="activtyDetailFlex">
                      {/* <p>
                        Day : <span className="blackText">{moment(selectActivityDayNewDetails).format("DD MMM")}</span>
                      </p> */}
                      {/* <p>
                        Duration: <span className="blackText">1 hrs</span>
                      </p> */}
                      <p style={{ position: "static" }}>
                        Location: <span className="blackText">{tourdataDetails?.tour_region_name != null ? (<>{tourdataDetails?.tour_location}, {tourdataDetails?.tour_region_name}</>) : (<>{tourdataDetails?.tour_location}</>)}</span>
                      </p>{" "}
                    </div>
                    <div className="makeFlex appendBottom16">
                      {/* <p className="latoBold font12 greyText2 appendTop2">
                        Suitable for -{" "}
                        <span className="blackText fw900">
                          Adult, Child, Infant, Youth, Senior, Teens
                        </span>
                      </p> */}
                    </div>{" "}
                    <div className="imgWrap3">
                    {/* <div
                  className="container"
                  style={{ marginTop: 60, maxWidth: "1210px" }}
                > */}
                  {/* <div className="DetailPageTitle">
                    <h4 className="title_dt">
                      {tourdataDetails.tour_name}
                    </h4>
                  </div> */}

                  <div
                    className="GalleryHeader"
                    style={{ display: "flex", flexDirection: "row" }}
                  >
                    <div style={{ width: "65%" }}>
                      <ImageGallery
                        items={tourGalleryDetails}
                        thumbnailPosition="right"
                        showFullscreenButton={false}
                        showIndex={true}
                        showPlayButton={false}
                      />
                    </div>

                    <div style={{ width: "35%", marginLeft: 10 }}>
                      <div className="check-availability-wrapper">
                        <div className="text-left">
                          <div className="mb-1 from-price-container">
                            <p className="h2 mb-0 text-dark from-price">
                              <span className="font-weight-bold text-lowercase from-price-text">
                                From{" "}
                              </span>
                              <span className="font-weight-normal price-font">
                                {tourPriceDetails != "" &&
                                tourPriceDetails.specialOffer !=
                                  "no_offer" ? (
                                  <>
                                    {getDetailsAmount(
                                      tourPriceDetails.specialOffer,
                                      tourPriceDetails.tour_price
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <p
                                      className="latoBlack font16 blackText appendBottom5"
                                      id="hlistpg_hotel_shown_price"
                                    >
                                      <span>€</span>
                                      {tourPriceDetails.tour_price}{" "}
                                    </p>
                                  </>
                                )}
                              </span>
                            </p>
                            <p className="blackText appendBottom5">
                            {tourPriceDetails != "" &&
                              tourPriceDetails?.tour_price_data
                                ?.price_plan_id == 2 ? (
                                <>Free</>
                              ) : tourPriceDetails?.tour_price_data
                                  ?.price_type_id == 1 ? (
                                <>Per Person</>
                              ) : (
                                <>
                                  Per Group (up to{" "}
                                  {tourPriceDetails.tour_price_data !=
                                    null &&
                                    tourPriceDetails.tour_price_data
                                      .group_max}
                                  )
                                </>
                              )}{" "}
                              {tourPriceDetails != "" &&
                              tourPriceDetails.tour_price_data
                                .flexible_id == 1 ? (
                                <>or Flexible rates</>
                              ) : (
                                <></>
                              )}
                            </p>
                          </div>
                        </div>
                        {/* <h3 className="font-weight-medium product-count-text">
                          Select Date and Travelers
                        </h3> */}

                        <div
                          className="dayPick"
                          onClick={() =>checkinandcheckoutActivity()}
                        >
                          <FontAwesomeIcon
                            icon={faCalendarCheck}
                            color="#000"
                            className="dayPickicon"
                          ></FontAwesomeIcon>
                          <p>{selectActivityDayDetails}</p>
                        </div>
                        {/* <div onClick={handleBodyClick}>
                          {checkinShowActivity && (
                            <DayPicker
                              className="activityDetailsDate"
                              onDayClick={() =>handleActivityDayClick()}
                              selectedDays={selectActivityDayNewDetails}
                              disabledDays={{ before: new Date() }}
                            />
                          )}
                        </div> */}
                        <h3 className="font-weight-medium product-count-text">Select Travelers</h3>
                        <div className="dayPick" 
                        onClick={() =>toggleDropdown()}
                        >
                          <FontAwesomeIcon
                            icon={faUserCircle}
                            color="#000"
                            className="dayPickicon"
                          ></FontAwesomeIcon>
                          <p>{numberTraveler}</p>
                        </div>
                        <div className={menuclassName} ref={myDivToFocus}>
                          {dropdownVisible &&
                            renderDropdownMenu()}
                        </div>

                        <div className="apply-button-changes-feature">
                          <button
                            className="btn btn-primary btn-block text-white check-avail-button"
                            onClick={() =>CheckAvailability()}
                          >
                            {checkName}
                          </button>
                        </div>
                        { tourFreeCancellationPolicyDetails != null &&
                       tourFreeCancellationPolicyDetails.map(
                        (item, index) => {
                         let DataNew = "";
                          if (item.cancellation_penalty_id == 1) { 
                            const selectActivityDay = selectActivityDayDetails;
                            const date = new Date(selectActivityDay);
                            if (item.day_before_arrival == 1 || item.day_before_arrival == 2) {
                              date.setDate(date.getDate() - item.day_before_arrival);
                              DataNew = moment(date).format("Do MMMM YYYY");
                            }
                            {
                              date.setDate(date.getDate() - (item.day_before_arrival - 2));
                               DataNew = moment(date).format("Do MMMM YYYY");
                            }
                            let CurrentDate = new Date();
                            let GivenDate = new Date(date);
                            if (GivenDate > CurrentDate) {
                            return ( 
                              <div className="freeCancellationDetails">
                                  Free Cancellation Until {DataNew} (local time)
                              </div>
                            );
                            }
                          } 
                        }
                      )}
                      </div>
                    </div>
                  </div>
                {/* </div> */}
                      {/* <div>
                        <div
                          className="imageLoaderContainer "
                          style={{ width: "519px", height: "200px" }}
                        >
                          <img
                            className=" active "
                            width="519"
                            height="200"
                            src="https://hldak.mmtcdn.com/prod-s3-activity-templates/activitiesImagesFinal/activity/GAG/ACT10000000020419_2.jpg"
                            style={{ borderRadius: "4px" }}
                          />
                        </div>
                      </div>
                      <div>
                        <div className="appendBottom6">
                          <div
                            className="imageLoaderContainer "
                            style={{ width: "200px", height: "100px" }}
                          >
                            <img
                              className=" active "
                              width="200"
                              height="100"
                              src="https://hldak.mmtcdn.com/prod-s3-activity-templates/activitiesImagesFinal/activity/GAG/ACT10000000020419_3.jpg"
                              style={{ borderRadius: "4px" }}
                            />
                          </div>
                        </div>
                        <div>
                          <div
                            className="imageLoaderContainer "
                            style={{ width: "200px", height: "100px" }}
                          >
                            <img
                              className=" active "
                              width="200"
                              height="100"
                              src="https://hldak.mmtcdn.com/prod-s3-activity-templates/activitiesImagesFinal/activity/GAG/ACT10000000020419_4.jpg"
                              style={{ borderRadius: "4px" }}
                            />
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                  {/* <ul className=" tripTab ">
                    <li id="About_0" className="selected">
                      About
                    </li>
                    <li id="Rate_Plan_1" className="">
                      Rate Plan
                    </li>
                    <li id="Inclusions_2" className="">
                      Inclusions
                    </li>
                  </ul> */}
                  <div className="scrollMargin100" id="About">
                    <div className="abtActivity">
                      <h3 className="latoBlack font16 appendBottom15">
                        About the Transfer
                      </h3>
                      <p className="font12 appendBottom18">
                        <p
                          style={{
                            display: "inlineBlock",
                            textAlign: "justify",
                          }}
                        >
                          <span className="activity-row-text-desc">
                          {ReactHtmlParser(tourDescriptionDetails.tour_overview)} 
                          </span>
                        </p>
                      </p>
                    </div>
                  </div>
                  {/* <div className="scrollMargin100" id="Rate_Plan">
                    <div className="ratePlanWrapper">
                      <div className="headerWrapper">
                        <h3 className="font16">Rate Plan - Package types</h3>
                        <p className="dateWrapper font12">
                          <span className="day">Day 1</span>{" "}
                          <span className="date">| 1 Dec, Friday</span>
                        </p>
                      </div>
                      <div
                        className="ratePlanCardWrapper selectedActivityCard"
                        data-testid="activity-rate-plan"
                      >
                        <h3 className="heading activityHeading font16 fw900 blackText">
                        ADVENTURERS FOOTSTEPS
                        </h3>
                        <div className="selectedButtonWrapper ratePlanSelectWrapper">
                          <div className="selectedBadgeWrapper priceSelected">
                            <span className="badgeBar"></span>
                            <div className="selectedBadgeContainer">
                              <div className="tickContainer">
                                <div className="tick"></div>
                              </div>
                              <span className="selectedBadgeText font10">
                                Selected
                              </span>
                            </div>
                          </div>
                        </div>
                        <p className="description font12 lineHeight16">
                          <span className="makeAllInline">
                            Complimentry lunch with Tour Manger Breifing
                          </span>
                           <span className="makeAllInline">
                           ADVENTURERS FOOTSTEPS Tour
                          </span>
                        </p>
                      </div>
                    </div>
                  </div> */}

                  <div className="scrollMargin100" id="Rate_Plan">
                    <div className="ratePlanWrapper">
                      <div className="headerWrapper">
                        <h3 className="font16">Rate Plan </h3>
                        {/* <p className="dateWrapper font12">
                          <span className="day">Day 1</span>{" "}
                          <span className="date">| 1 Dec, Friday</span>
                        </p> */}
                      </div>
                      <div
                        className="ratePlanCardWrapper selectedActivityCard"
                        data-testid="activity-rate-plan"
                      >
                        {/* <h3 className="heading activityHeading font16 fw900 blackText">
                        ADVENTURERS FOOTSTEPS
                        </h3>
                        <div className="selectedButtonWrapper ratePlanSelectWrapper">
                          <div className="selectedBadgeWrapper priceSelected">
                            <span className="badgeBar"></span>
                            <div className="selectedBadgeContainer">
                              <div className="tickContainer">
                                <div className="tick"></div>
                              </div>
                              <span className="selectedBadgeText font10">
                                Selected
                              </span>
                            </div>
                          </div>
                        </div>
                        <p className="description font12 lineHeight16">
                          <span className="makeAllInline">
                            Complimentry lunch with Tour Manger Breifing
                          </span>
                           <span className="makeAllInline">
                           ADVENTURERS FOOTSTEPS Tour
                          </span>
                        </p> */}
                        {show_options == true ? (
                  <>
                    {tour_options == null ? (
                      <div className="tour-grade-loading-wrapper container">
                        <div className="loading-wrapper mb-3">
                          <div className="loading-message px-lg-3 py-3">
                            Loading available options...
                          </div>
                          <Skeleton
                            style={{
                              width: "95%",
                              height: 20,
                              marginBottom: 10,
                              marginTop: 10,
                            }}
                          />
                          <Skeleton
                            style={{
                              width: "90%",
                              height: 20,
                              marginBottom: 10,
                            }}
                          />
                          <Skeleton
                            style={{
                              width: "80%",
                              height: 20,
                              marginBottom: 10,
                            }}
                          />
                          <Skeleton
                            style={{
                              width: "70%",
                              height: 20,
                              marginBottom: 10,
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <>
                        {tour_options.options != "no_priceoption" ? (
                          <>
                            {tour_options.options.map((i, j) => {
                              if (i != "no_priceoption") {
                                if (i != null) {
                                  return (
                                    <div className="pax-container d-flex container px-0 flex-column flex-lg-row">
                                      <div className="tg-container-left d-flex flex-column align-items-start p-lg-4 px-3 pt-3 pb-4  long-button ">
                                        {tour_options.options
                                          .length > 1 && (
                                          <div class="d-flex justify-content-start">
                                            <div class="option-pill py-1 mr-2 my-1 font-weight-lighter align-self-end  text-nowrap rounded text-center">
                                              Option {j + 1}
                                            </div>
                                          </div>
                                        )}

                                        <div className="px-0">
                                          <label
                                            for="rb0"
                                            className="mb-0 w-100 enabled"
                                          >
                                            <div className="tour-grade-title h3 mb-0 font-weight-medium tg-title">
                                              {i.option_name}
                                            </div>
                                          </label>
                                        </div>
                                        <div className="tour-option-details w-100">
                                          <div
                                            className="description-wrapper d-flex py-3 ie-overflow-fix"
                                            data-description-preview-length="300"
                                          >
                                            {/* <div className="tg-description">
                                  <div>
                                    {ReactHtmlParser(
                                      `${i.tour_overview.substring(0, 300)}...`
                                    )}
                                  </div>
                                </div> */}
                                          </div>
                                          <div className="start-time-section">
                                            <div className="tg-start-times">
                                              <div className="start-times pl-sm-2 pl-lg-0 d-flex justify-content-start flex-wrap ie-overflow-fix content-show">
                                                {i.timing == "unavailable" && (
                                                  <div className="start-time rounded  text-center text-nowrap available selected">
                                                    No Availability
                                                  </div>
                                                )}
                                                {i.timing != "unavailable" &&
                                                  i.timing != null &&
                                                  i.timing.map(
                                                    (item, index) => {
                                                      return i.timing != null &&
                                                        i.timing.length > 1 ? (
                                                        <>
                                                          <div
                                                            className={`start-time rounded  text-center text-nowrap available ${
                                                              j + "_" + index ==
                                                               selectedIndex &&
                                                              "selected"
                                                            }`}
                                                            onClick={() =>
                                                              setTimeSelected(
                                                                item,
                                                                index,
                                                                j
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                          >
                                                            {item.from_time}
                                                          </div>
                                                        </>
                                                      ) : (
                                                        <div
                                                          className="start-time rounded  text-center text-nowrap available selected"
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                        >
                                                          {item.from_time}
                                                        </div>
                                                      );
                                                    }
                                                  )}
                                                {i.timing != "unavailable" &&
                                                  i.timing == null && (
                                                    <div className="start-time rounded  text-center text-nowrap available selected">
                                                      Coordinated Times
                                                    </div>
                                                  )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="book-section-separator d-none"></div>
                                      <div className="book-section py-4 px-3 flex-grow-1  available  long-button ">
                                        <div className="add-to-cart-section h-100 clearfix">
                                          <div
                                            id="add-to-cart-0"
                                            className="add-to-cart-container d-flex flex-wrap-reverse h-100 rnpl"
                                          >
                                            <div
                                              className="cart-option-buttons"
                                              style={{ marginTop: 10 }}
                                            >
                                              <div
                                                className="add-to-cart-wrapper float-right d-flex flex-column my-1 justify-content-end "
                                                style={{ width: "85%" }}
                                              >
                                                <div
                                                  className="no-time-selected-popover p-0"
                                                  tabindex="0"
                                                >
                                                  {i.timing != null &&
                                                  i.timing.length > 1 ? (
                                                    j ==selectedIndexNew ? (
                                                      <a
                                                        className="btn btn-primary add-to-cart w-100"
                                                        style={{
                                                          color: "#fff",
                                                        }}
                                                        disabled={DisableSelectButton}
                                                        onClick={() => {
                                                          handleClick(
                                                            i,
                                                            i.tour_id,
                                                            selectActivityDayNewDetails,
                                                            tourSingleTourGalleryDetails,
                                                            selectedTime,
                                                            i.id,
                                                            JSON.stringify(carts),
                                                            tourdataDetails.tour_name,
                                                            i.option_name,
                                                            tourdataDetails.tour_location,
                                                           selectedTimeValue,
                                                           tourPriceDetails.price_options.price_type,
                                                            tourdataDetails.tour_operator_id,
                                                            tourExtrachargesDetails,
                                                            tourCancellationPolicyDetails,
                                                            tourFreeCancellationPolicyDetails,
                                                          );
                                                        }}
                                                      >
                                                        Add Transfer
                                                      </a>
                                                    ) : (
                                                      <div
                                                        className="btn btn-primary add-to-cart w-100 disabled"
                                                        data-tip="true"
                                                        data-for={i.id}
                                                        currentitem="false"
                                                      >
                                                        <div className="button-text">
                                                          Add Transfer
                                                        </div>
                                                        <div className="loading-bubbles primary d-none">
                                                          <span></span>
                                                          <span></span>
                                                          <span></span>
                                                        </div>
                                                        <ReactTooltip
                                                          id={i.id}
                                                          place="top"
                                                          type="dark"
                                                        >
                                                          <span>
                                                            Select a time to
                                                            book{" "}
                                                          </span>
                                                        </ReactTooltip>
                                                      </div>
                                                    )
                                                  ) : (
                                                    <a
                                                      className="btn btn-primary add-to-cart w-100"
                                                      style={{ color: "#fff" }}
                                                      disabled={DisableSelectButton}
                                                      onClick={() => {
                                                        handleClick(
                                                          i,
                                                          i.tour_id,
                                                          selectActivityDayNewDetails,
                                                          tourSingleTourGalleryDetails,
                                                          selectedTime,
                                                          i.id,
                                                          JSON.stringify(carts),
                                                          tourdataDetails.tour_name,
                                                          i.option_name,
                                                          tourdataDetails.tour_location,
                                                          i.timing == null? null: i.timing[0].from_time,
                                                          tourPriceDetails.price_options.price_type,
                                                          tourdataDetails.tour_operator_id,
                                                          tourExtrachargesDetails,
                                                          tourCancellationPolicyDetails,
                                                          tourFreeCancellationPolicyDetails,
                                                        );
                                                      }}
                                                    >
                                                      Add Transfer
                                                    </a>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                            {i.timing != "unavailable" && (
                                              <div className="price-total d-flex flex-row flex-lg-column w-100 align-items-lg-end justify-content-between  ">
                                                <span
                                                  className="font-weight-bold price-display"
                                                  data-automation="price-display"
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faEuroSign}
                                                    color="#000"
                                                    style={{ fontSize: "13px" }}
                                                  ></FontAwesomeIcon>{" "}
                                                  {i.price[0].map(
                                                    (item, index) => {
                                                      if (
                                                        item.price_plan_id ==
                                                        1
                                                      ) {
                                                      if (
                                                        item.group_price > 0
                                                      ) {
                                                        if (
                                                          item.flexible_id == 0
                                                        ) {
                                                          let GroupTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.groupCounter *
                                                                1,
                                                            0
                                                          );

                                                          if (
                                                            GroupTraveler <=
                                                            item.group_max
                                                          ) {
                                                            if (
                                                              i.specialOffer !=
                                                              "no_offer"
                                                            ) {
                                                              let result = [];

                                                              i.specialOffer.map(
                                                                (l, j) => {
                                                                  if (
                                                                    l.combineoffer ==
                                                                    "nocombine"
                                                                  ) {
                                                                    if (
                                                                      l
                                                                        .specialdata
                                                                        .discount_id ==
                                                                      2
                                                                    ) {
                                                                      const disA =
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    } else {
                                                                      const disA =
                                                                        item.group_price -
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    }
                                                                  } else {
                                                                    if (
                                                                      l
                                                                        .specialdata
                                                                        .discount_id ==
                                                                      2
                                                                    ) {
                                                                      const disA =
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    } else {
                                                                      const disA =
                                                                        item.group_price -
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    }
                                                                  }
                                                                }
                                                              );

                                                              const Amount = result
                                                                .reduce(
                                                                  (a, v) =>
                                                                    a + v * 1,
                                                                  0
                                                                )
                                                                .toFixed(2);
                                                              const $UpliftAmountGroup =
                                                                (parseInt(
                                                                  i
                                                                    .priceuplift[0]
                                                                ) /
                                                                  100) *
                                                                item.group_price;
                                                              const UpliftGroupAmount =
                                                                parseInt(
                                                                  item.group_price
                                                                ) +
                                                                $UpliftAmountGroup;

                                                              const balanceAmount =
                                                                UpliftGroupAmount -
                                                                (
                                                                  Math.round(
                                                                    Amount *
                                                                      UpliftGroupAmount
                                                                  ) / 100
                                                                ).toFixed(2);

                                                              return balanceAmount;
                                                            } else {
                                                              const $UpliftAmountGroup =
                                                                (parseInt(
                                                                  i
                                                                    .priceuplift[0]
                                                                ) /
                                                                  100) *
                                                                item.group_price;
                                                              const UpliftGroupAmount =
                                                                parseInt(
                                                                  item.group_price
                                                                ) +
                                                                $UpliftAmountGroup;
                                                              return UpliftGroupAmount;
                                                              //return item.group_price;
                                                            }
                                                          }
                                                        } else {
                                                          let GroupTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.groupCounter *
                                                                1,
                                                            0
                                                          );

                                                          if (
                                                            GroupTraveler <=
                                                              item.group_max &&
                                                            GroupTraveler >=
                                                              item.group_min
                                                          ) {
                                                            if (
                                                              i.specialOffer !=
                                                              "no_offer"
                                                            ) {
                                                              let result = [];

                                                              i.specialOffer.map(
                                                                (l, j) => {
                                                                  if (
                                                                    l.combineoffer ==
                                                                    "nocombine"
                                                                  ) {
                                                                    if (
                                                                      l
                                                                        .specialdata
                                                                        .discount_id ==
                                                                      2
                                                                    ) {
                                                                      const disA =
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    } else {
                                                                      const disA =
                                                                        item.group_price -
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    }
                                                                  } else {
                                                                    if (
                                                                      l
                                                                        .specialdata
                                                                        .discount_id ==
                                                                      2
                                                                    ) {
                                                                      const disA =
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    } else {
                                                                      const disA =
                                                                        item.group_price -
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    }
                                                                  }
                                                                }
                                                              );

                                                              const Amount = result
                                                                .reduce(
                                                                  (a, v) =>
                                                                    a + v * 1,
                                                                  0
                                                                )
                                                                .toFixed(2);
                                                              const $UpliftAmountGroup =
                                                                (parseInt(
                                                                  i
                                                                    .priceuplift[0]
                                                                ) /
                                                                  100) *
                                                                item.group_price;
                                                              const UpliftGroupAmount =
                                                                parseInt(
                                                                  item.group_price
                                                                ) +
                                                                $UpliftAmountGroup;

                                                              const balanceAmount =
                                                                UpliftGroupAmount -
                                                                (
                                                                  Math.round(
                                                                    Amount *
                                                                      UpliftGroupAmount
                                                                  ) / 100
                                                                ).toFixed(2);

                                                              return balanceAmount;
                                                            } else {
                                                              const $UpliftAmountGroup =
                                                                (parseInt(
                                                                  i
                                                                    .priceuplift[0]
                                                                ) /
                                                                  100) *
                                                                item.group_price;
                                                              const UpliftGroupAmount =
                                                                parseInt(
                                                                  item.group_price
                                                                ) +
                                                                $UpliftAmountGroup;
                                                              return UpliftGroupAmount;
                                                              //return item.group_price;
                                                            }
                                                          }
                                                        }
                                                      } else {
                                                        let total = "";

                                                        if (
                                                          item.flexible_id == 0
                                                        ) {
                                                          let adult_P = 0;
                                                          let adultTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.adultCounter *
                                                                1,
                                                            0
                                                          );
                                                          let infantTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.infantCounter *
                                                                1,
                                                            0
                                                          );
                                                          let childTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.childCounter *
                                                                1,
                                                            0
                                                          );
                                                          let youthTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.youthCounter *
                                                                1,
                                                            0
                                                          );
                                                          let seniorTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.seniorCounter *
                                                                1,
                                                            0
                                                          );

                                                          if (
                                                            item.adult_price > 0
                                                          ) {
                                                            adult_P =
                                                              item.adult_price *
                                                              adultTraveler;
                                                          }
                                                          let infant_P = 0;
                                                          if (
                                                            item.infant_price >
                                                            0
                                                          ) {
                                                            infant_P =
                                                              item.infant_price *
                                                              infantTraveler;
                                                          }
                                                          let child_P = 0;
                                                          if (
                                                            item.child_price > 0
                                                          ) {
                                                            child_P =
                                                              item.child_price *
                                                              childTraveler;
                                                          }
                                                          let youth_P = 0;
                                                          if (
                                                            item.youth_price > 0
                                                          ) {
                                                            youth_P =
                                                              item.youth_price *
                                                              youthTraveler;
                                                          }
                                                          let senior_P = 0;
                                                          if (
                                                            item.senior_price >
                                                            0
                                                          ) {
                                                            senior_P =
                                                              item.senior_price *
                                                              seniorTraveler;
                                                          }

                                                          total =
                                                            adult_P +
                                                            infant_P +
                                                            child_P +
                                                            youth_P +
                                                            senior_P;

                                                          if (
                                                            i.specialOffer !=
                                                            "no_offer"
                                                          ) {
                                                            let result = [];

                                                            i.specialOffer.map(
                                                              (l, j) => {
                                                                if (
                                                                  l.combineoffer ==
                                                                  "nocombine"
                                                                ) {
                                                                  if (
                                                                    l
                                                                      .specialdata
                                                                      .discount_id ==
                                                                    2
                                                                  ) {
                                                                    const disA =
                                                                      l
                                                                        .specialdata
                                                                        .rate_amount;
                                                                    result.push(
                                                                      +disA
                                                                    );
                                                                  } else {
                                                                    const disA =
                                                                      total -
                                                                      l
                                                                        .specialdata
                                                                        .rate_amount;
                                                                    result.push(
                                                                      +disA
                                                                    );
                                                                  }
                                                                } else {
                                                                  if (
                                                                    l
                                                                      .specialdata
                                                                      .discount_id ==
                                                                    2
                                                                  ) {
                                                                    const disA =
                                                                      l
                                                                        .specialdata
                                                                        .rate_amount;
                                                                    result.push(
                                                                      +disA
                                                                    );
                                                                  } else {
                                                                    const disA =
                                                                      total -
                                                                      l
                                                                        .specialdata
                                                                        .rate_amount;
                                                                    result.push(
                                                                      +disA
                                                                    );
                                                                  }
                                                                }
                                                              }
                                                            );

                                                            const Amount = result
                                                              .reduce(
                                                                (a, v) =>
                                                                  a + v * 1,
                                                                0
                                                              )
                                                              .toFixed(2);
                                                            const $UpliftAmountTotal =
                                                              (parseInt(
                                                                i.priceuplift[0]
                                                              ) /
                                                                100) *
                                                              total;
                                                            const UpliftGroupTotal =
                                                              parseInt(total) +
                                                              $UpliftAmountTotal;
                                                            const balanceAmount =
                                                              UpliftGroupTotal -
                                                              (
                                                                Math.round(
                                                                  Amount *
                                                                    UpliftGroupTotal
                                                                ) / 100
                                                              ).toFixed(2);

                                                            return balanceAmount;
                                                          } else {
                                                            const $UpliftAmountTotal =
                                                              (parseInt(
                                                                i.priceuplift[0]
                                                              ) /
                                                                100) *
                                                              total;
                                                            const UpliftGroupAmount =
                                                              parseInt(total) +
                                                              $UpliftAmountTotal;
                                                            return UpliftGroupAmount;
                                                            // return total;
                                                          }

                                                          // return total;
                                                        } else {
                                                          if (index == 0) {
                                                            let adultTraveler = carts.reduce(
                                                              (a, v) =>
                                                                a +
                                                                v.adultCounter *
                                                                  1,
                                                              0
                                                            );
                                                            let infantTraveler = carts.reduce(
                                                              (a, v) =>
                                                                a +
                                                                v.infantCounter *
                                                                  1,
                                                              0
                                                            );
                                                            let childTraveler = carts.reduce(
                                                              (a, v) =>
                                                                a +
                                                                v.childCounter *
                                                                  1,
                                                              0
                                                            );
                                                            let youthTraveler = carts.reduce(
                                                              (a, v) =>
                                                                a +
                                                                v.youthCounter *
                                                                  1,
                                                              0
                                                            );
                                                            let seniorTraveler = carts.reduce(
                                                              (a, v) =>
                                                                a +
                                                                v.seniorCounter *
                                                                  1,
                                                              0
                                                            );

                                                            let adult_P = 0;
                                                            if (
                                                              adultTraveler > 0
                                                            ) {
                                                              let AdultTo = i.price[0].filter(
                                                                (i) =>
                                                                  adultTraveler <=
                                                                    i.adult_max &&
                                                                  adultTraveler >=
                                                                    i.adult_min
                                                              );

                                                              if (
                                                                AdultTo.length >
                                                                0
                                                              ) {
                                                                adult_P =
                                                                  AdultTo[0]
                                                                    .adult_price *
                                                                  adultTraveler;
                                                              }
                                                            }
                                                            let infant_P = 0;
                                                            if (
                                                              infantTraveler > 0
                                                            ) {
                                                              let infantTo = i.price[0].filter(
                                                                (i) =>
                                                                  infantTraveler <=
                                                                    i.infant_max &&
                                                                  infantTraveler >=
                                                                    i.infant_min
                                                              );

                                                              if (
                                                                infantTo.length >
                                                                0
                                                              ) {
                                                                infant_P =
                                                                  infantTo[0]
                                                                    .infant_price *
                                                                  infantTraveler;
                                                              }
                                                            }
                                                            let child_P = 0;
                                                            if (
                                                              childTraveler > 0
                                                            ) {
                                                              let childTo = i.price[0].filter(
                                                                (i) =>
                                                                  childTraveler <=
                                                                    i.child_max &&
                                                                  childTraveler >=
                                                                    i.child_min
                                                              );

                                                              if (
                                                                childTo.length >
                                                                0
                                                              ) {
                                                                child_P =
                                                                  childTo[0]
                                                                    .child_price *
                                                                  childTraveler;
                                                              }
                                                            }
                                                            let youth_P = 0;
                                                            if (
                                                              youthTraveler > 0
                                                            ) {
                                                              let youthTo = i.price[0].filter(
                                                                (i) =>
                                                                  youthTraveler <=
                                                                    i.youth_max &&
                                                                  youthTraveler >=
                                                                    i.youth_min
                                                              );

                                                              if (
                                                                youthTo.length >
                                                                0
                                                              ) {
                                                                youth_P =
                                                                  youthTo[0]
                                                                    .youth_price *
                                                                  youthTraveler;
                                                              }
                                                            }

                                                            let senior_P = 0;
                                                            if (
                                                              seniorTraveler > 0
                                                            ) {
                                                              let seniorTo = i.price[0].filter(
                                                                (i) =>
                                                                  seniorTraveler <=
                                                                    i.senior_max &&
                                                                  seniorTraveler >=
                                                                    i.senior_min
                                                              );

                                                              if (
                                                                seniorTo.length >
                                                                0
                                                              ) {
                                                                senior_P =
                                                                  seniorTo[0]
                                                                    .senior_price *
                                                                  seniorTraveler;
                                                              }
                                                            }

                                                            total =
                                                              adult_P * 1 +
                                                              infant_P * 1 +
                                                              child_P * 1 +
                                                              youth_P * 1 +
                                                              senior_P * 1;

                                                            if (total != 0) {
                                                              if (
                                                                i.specialOffer !=
                                                                "no_offer"
                                                              ) {
                                                                let result = [];

                                                                i.specialOffer.map(
                                                                  (l, j) => {
                                                                    if (
                                                                      l.combineoffer ==
                                                                      "nocombine"
                                                                    ) {
                                                                      if (
                                                                        l
                                                                          .specialdata
                                                                          .discount_id ==
                                                                        2
                                                                      ) {
                                                                        const disA =
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      } else {
                                                                        const disA =
                                                                          total -
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      }
                                                                    } else {
                                                                      if (
                                                                        l
                                                                          .specialdata
                                                                          .discount_id ==
                                                                        2
                                                                      ) {
                                                                        const disA =
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      } else {
                                                                        const disA =
                                                                          total -
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      }
                                                                    }
                                                                  }
                                                                );

                                                                const Amount = result
                                                                  .reduce(
                                                                    (a, v) =>
                                                                      a + v * 1,
                                                                    0
                                                                  )
                                                                  .toFixed(2);

                                                                const $UpliftAmountTotal =
                                                                  (parseInt(
                                                                    i
                                                                      .priceuplift[0]
                                                                  ) /
                                                                    100) *
                                                                  total;
                                                                const UpliftGroupTotal =
                                                                  parseInt(
                                                                    total
                                                                  ) +
                                                                  $UpliftAmountTotal;

                                                                const balanceAmount =
                                                                  UpliftGroupTotal -
                                                                  (
                                                                    Math.round(
                                                                      Amount *
                                                                        UpliftGroupTotal
                                                                    ) / 100
                                                                  ).toFixed(2);

                                                                return balanceAmount;
                                                              } else {
                                                                const $UpliftAmountTotal =
                                                                  (parseInt(
                                                                    i
                                                                      .priceuplift[0]
                                                                  ) /
                                                                    100) *
                                                                  total;
                                                                const UpliftGroupTotal =
                                                                  parseInt(
                                                                    total
                                                                  ) +
                                                                  $UpliftAmountTotal;
                                                                return UpliftGroupTotal;
                                                              }

                                                              //return total;
                                                            }
                                                          }
                                                        }
                                                      }
                                                    } else {
                                                      return 0;
                                                    }
                                                    }
                                                  )}
                                                </span>{" "}
                                                <span
                                                  className="price-break-down-cta text-nowrap text-right"
                                                  data-automation="price-break-down-cta"
                                                >
                                                  {i.price[0].map(
                                                    (item, index) => {
                                                      if (
                                                        item.group_price > 0
                                                      ) {
                                                        if (
                                                          item.flexible_id == 0
                                                        ) {
                                                          let GroupTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.groupCounter *
                                                                1,
                                                            0
                                                          );

                                                          if (
                                                            GroupTraveler <=
                                                            item.group_max
                                                          ) {
                                                            return (
                                                              "per group (up to " +
                                                              item.group_max +
                                                              " )"
                                                            );
                                                          }
                                                        } else {
                                                          let GroupTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.groupCounter *
                                                                1,
                                                            0
                                                          );

                                                          if (
                                                            GroupTraveler <=
                                                              item.group_max &&
                                                            GroupTraveler >=
                                                              item.group_min
                                                          ) {
                                                            return (
                                                              "per group (up to " +
                                                              item.group_max +
                                                              " )"
                                                            );
                                                          }
                                                        }
                                                      } else {
                                                        let total = "";
                                                        if (
                                                          item.flexible_id == 0
                                                        ) {
                                                          let adult_P = "";
                                                          let adultTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.adultCounter *
                                                                1,
                                                            0
                                                          );
                                                          let infantTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.infantCounter *
                                                                1,
                                                            0
                                                          );
                                                          let childTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.childCounter *
                                                                1,
                                                            0
                                                          );
                                                          let youthTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.youthCounter *
                                                                1,
                                                            0
                                                          );
                                                          let seniorTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.seniorCounter *
                                                                1,
                                                            0
                                                          );
                                                          let adultprice = "";
                                                          if (
                                                            adultTraveler > 0
                                                          ) {
                                                            if (
                                                              i.specialOffer !=
                                                              "no_offer"
                                                            ) {
                                                              let result = [];

                                                              i.specialOffer.map(
                                                                (l, j) => {
                                                                  if (
                                                                    l.combineoffer ==
                                                                    "nocombine"
                                                                  ) {
                                                                    if (
                                                                      l
                                                                        .specialdata
                                                                        .discount_id ==
                                                                      2
                                                                    ) {
                                                                      const disA =
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    } else {
                                                                      const disA =
                                                                        item.adult_price -
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    }
                                                                  } else {
                                                                    if (
                                                                      l
                                                                        .specialdata
                                                                        .discount_id ==
                                                                      2
                                                                    ) {
                                                                      const disA =
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    } else {
                                                                      const disA =
                                                                        item.adult_price -
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    }
                                                                  }
                                                                }
                                                              );

                                                              const Amount = result
                                                                .reduce(
                                                                  (a, v) =>
                                                                    a + v * 1,
                                                                  0
                                                                )
                                                                .toFixed(2);

                                                              const $UpliftAmountAdult =
                                                                (parseInt(
                                                                  i
                                                                    .priceuplift[0]
                                                                ) /
                                                                  100) *
                                                                item.adult_price;
                                                              const UpliftGroupAdult =
                                                                parseInt(
                                                                  item.adult_price
                                                                ) +
                                                                $UpliftAmountAdult;
                                                              const balanceAmount =
                                                                UpliftGroupAdult -
                                                                (
                                                                  Math.round(
                                                                    Amount *
                                                                      UpliftGroupAdult
                                                                  ) / 100
                                                                ).toFixed(2);
                                                              adultprice = balanceAmount;
                                                            } else {
                                                              const $UpliftAmountAdult =
                                                                (parseInt(
                                                                  i
                                                                    .priceuplift[0]
                                                                ) /
                                                                  100) *
                                                                item.adult_price;
                                                              const UpliftGroupAdult =
                                                                parseInt(
                                                                  item.adult_price
                                                                ) +
                                                                $UpliftAmountAdult;
                                                              adultprice = UpliftGroupAdult;
                                                            }

                                                            adultTraveler == 1
                                                              ? (adult_P =
                                                                  adultTraveler +
                                                                  " Adults x " +
                                                                  " <img src='images/euro.png' />" +
                                                                  adultprice +
                                                                  "=" +
                                                                  " <img src='images/euro.png' />" +
                                                                  (
                                                                    adultprice *
                                                                    adultTraveler
                                                                  ).toFixed(2) +
                                                                  "<br/>")
                                                              : (adult_P =
                                                                  adultTraveler +
                                                                  " Adults x " +
                                                                  " <img src='images/euro.png' />" +
                                                                  adultprice +
                                                                  "=" +
                                                                  " <img src='images/euro.png' />" +
                                                                  (
                                                                    adultprice *
                                                                    adultTraveler
                                                                  ).toFixed(2) +
                                                                  "<br/>");
                                                          }

                                                          let infant_P = "";
                                                          let infantprice = "";
                                                          if (
                                                            infantTraveler > 0
                                                          ) {
                                                            if (
                                                              i.specialOffer !=
                                                              "no_offer"
                                                            ) {
                                                              let result = [];

                                                              i.specialOffer.map(
                                                                (l, j) => {
                                                                  if (
                                                                    l.combineoffer ==
                                                                    "nocombine"
                                                                  ) {
                                                                    if (
                                                                      l
                                                                        .specialdata
                                                                        .discount_id ==
                                                                      2
                                                                    ) {
                                                                      const disA =
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    } else {
                                                                      const disA =
                                                                        item.infant_price -
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    }
                                                                  } else {
                                                                    if (
                                                                      l
                                                                        .specialdata
                                                                        .discount_id ==
                                                                      2
                                                                    ) {
                                                                      const disA =
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    } else {
                                                                      const disA =
                                                                        item.infant_price -
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    }
                                                                  }
                                                                }
                                                              );

                                                              const Amount = result
                                                                .reduce(
                                                                  (a, v) =>
                                                                    a + v * 1,
                                                                  0
                                                                )
                                                                .toFixed(2);

                                                              const $UpliftAmountInfant =
                                                                (parseInt(
                                                                  i
                                                                    .priceuplift[0]
                                                                ) /
                                                                  100) *
                                                                item.infant_price;
                                                              const UpliftGroupInfant =
                                                                parseInt(
                                                                  item.infant_price
                                                                ) +
                                                                $UpliftAmountInfant;
                                                              const balanceAmount =
                                                                UpliftGroupInfant -
                                                                (
                                                                  Math.round(
                                                                    Amount *
                                                                      UpliftGroupInfant
                                                                  ) / 100
                                                                ).toFixed(2);
                                                              infantprice = balanceAmount;
                                                            } else {
                                                              const $UpliftAmountInfant =
                                                                (parseInt(
                                                                  i
                                                                    .priceuplift[0]
                                                                ) /
                                                                  100) *
                                                                item.infant_price;
                                                              const UpliftGroupInfant =
                                                                parseInt(
                                                                  item.infant_price
                                                                ) +
                                                                $UpliftAmountInfant;
                                                              infantprice = UpliftGroupInfant;
                                                            }
                                                            infantTraveler == 1
                                                              ? (infant_P =
                                                                  infantTraveler +
                                                                  " Infant x " +
                                                                  " <img src='images/euro.png' />" +
                                                                  infantprice +
                                                                  "=" +
                                                                  " <img src='images/euro.png' />" +
                                                                  (
                                                                    infantprice *
                                                                    infantTraveler
                                                                  ).toFixed(2) +
                                                                  "<br/>")
                                                              : (infant_P =
                                                                  infantTraveler +
                                                                  " Infants x " +
                                                                  " <img src='images/euro.png' />" +
                                                                  infantprice +
                                                                  "=" +
                                                                  " <img src='images/euro.png' />" +
                                                                  (
                                                                    infantprice *
                                                                    infantTraveler
                                                                  ).toFixed(2) +
                                                                  "<br/>");
                                                          }
                                                          let child_P = "";
                                                          let childprice = "";
                                                          if (
                                                            childTraveler > 0
                                                          ) {
                                                            if (
                                                              i.specialOffer !=
                                                              "no_offer"
                                                            ) {
                                                              let result = [];

                                                              i.specialOffer.map(
                                                                (l, j) => {
                                                                  if (
                                                                    l.combineoffer ==
                                                                    "nocombine"
                                                                  ) {
                                                                    if (
                                                                      l
                                                                        .specialdata
                                                                        .discount_id ==
                                                                      2
                                                                    ) {
                                                                      const disA =
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    } else {
                                                                      const disA =
                                                                        item.child_price -
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    }
                                                                  } else {
                                                                    if (
                                                                      l
                                                                        .specialdata
                                                                        .discount_id ==
                                                                      2
                                                                    ) {
                                                                      const disA =
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    } else {
                                                                      const disA =
                                                                        item.child_price -
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    }
                                                                  }
                                                                }
                                                              );

                                                              const Amount = result
                                                                .reduce(
                                                                  (a, v) =>
                                                                    a + v * 1,
                                                                  0
                                                                )
                                                                .toFixed(2);
                                                              const $UpliftAmountChild =
                                                                (parseInt(
                                                                  i
                                                                    .priceuplift[0]
                                                                ) /
                                                                  100) *
                                                                item.child_price;
                                                              const UpliftGroupChild =
                                                                parseInt(
                                                                  item.child_price
                                                                ) +
                                                                $UpliftAmountChild;
                                                              const balanceAmount =
                                                                UpliftGroupChild -
                                                                (
                                                                  Math.round(
                                                                    Amount *
                                                                      UpliftGroupChild
                                                                  ) / 100
                                                                ).toFixed(2);
                                                              childprice = balanceAmount;
                                                            } else {
                                                              const $UpliftAmountChild =
                                                                (parseInt(
                                                                  i
                                                                    .priceuplift[0]
                                                                ) /
                                                                  100) *
                                                                item.child_price;
                                                              const UpliftGroupChild =
                                                                parseInt(
                                                                  item.child_price
                                                                ) +
                                                                $UpliftAmountChild;
                                                              childprice = UpliftGroupChild;
                                                            }
                                                            childTraveler == 1
                                                              ? (child_P =
                                                                  childTraveler +
                                                                  " Child x " +
                                                                  " <img src='images/euro.png' />" +
                                                                  childprice +
                                                                  "=" +
                                                                  " <img src='images/euro.png' />" +
                                                                  (
                                                                    childprice *
                                                                    childTraveler
                                                                  ).toFixed(2) +
                                                                  "<br/>")
                                                              : (child_P =
                                                                  childTraveler +
                                                                  " Childs x " +
                                                                  " <img src='images/euro.png' />" +
                                                                  childprice +
                                                                  "=" +
                                                                  " <img src='images/euro.png' />" +
                                                                  (
                                                                    childprice *
                                                                    childTraveler
                                                                  ).toFixed(2) +
                                                                  "<br/>");
                                                          }
                                                          let youth_P = "";
                                                          let youthprice = "";
                                                          if (
                                                            youthTraveler > 0
                                                          ) {
                                                            if (
                                                              i.specialOffer !=
                                                              "no_offer"
                                                            ) {
                                                              let result = [];

                                                              i.specialOffer.map(
                                                                (l, j) => {
                                                                  if (
                                                                    l.combineoffer ==
                                                                    "nocombine"
                                                                  ) {
                                                                    if (
                                                                      l
                                                                        .specialdata
                                                                        .discount_id ==
                                                                      2
                                                                    ) {
                                                                      const disA =
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    } else {
                                                                      const disA =
                                                                        item.youth_price -
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    }
                                                                  } else {
                                                                    if (
                                                                      l
                                                                        .specialdata
                                                                        .discount_id ==
                                                                      2
                                                                    ) {
                                                                      const disA =
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    } else {
                                                                      const disA =
                                                                        item.youth_price -
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    }
                                                                  }
                                                                }
                                                              );

                                                              const Amount = result
                                                                .reduce(
                                                                  (a, v) =>
                                                                    a + v * 1,
                                                                  0
                                                                )
                                                                .toFixed(2);

                                                              const $UpliftAmountYouth =
                                                                (parseInt(
                                                                  i
                                                                    .priceuplift[0]
                                                                ) /
                                                                  100) *
                                                                item.youth_price;
                                                              const UpliftGroupYouth =
                                                                parseInt(
                                                                  item.youth_price
                                                                ) +
                                                                $UpliftAmountYouth;
                                                              const balanceAmount =
                                                                UpliftGroupYouth -
                                                                (
                                                                  Math.round(
                                                                    Amount *
                                                                      UpliftGroupYouth
                                                                  ) / 100
                                                                ).toFixed(2);
                                                              youthprice = balanceAmount;
                                                            } else {
                                                              const $UpliftAmountYouth =
                                                                (parseInt(
                                                                  i
                                                                    .priceuplift[0]
                                                                ) /
                                                                  100) *
                                                                item.youth_price;
                                                              const UpliftGroupYouth =
                                                                parseInt(
                                                                  item.youth_price
                                                                ) +
                                                                $UpliftAmountYouth;
                                                              youthprice = UpliftGroupYouth;
                                                            }
                                                            youthTraveler == 1
                                                              ? (youth_P =
                                                                  youthTraveler +
                                                                  " Youth x " +
                                                                  " <img src='images/euro.png' />" +
                                                                  youthprice +
                                                                  "=" +
                                                                  " <img src='images/euro.png' />" +
                                                                  (
                                                                    youthprice *
                                                                    youthTraveler
                                                                  ).toFixed(2) +
                                                                  "<br/>")
                                                              : (youth_P =
                                                                  youthTraveler +
                                                                  " Youths x " +
                                                                  " <img src='images/euro.png' />" +
                                                                  youthprice +
                                                                  "=" +
                                                                  " <img src='images/euro.png' />" +
                                                                  (
                                                                    youthprice *
                                                                    youthTraveler
                                                                  ).toFixed(2) +
                                                                  "<br/>");
                                                          }
                                                          let senior_P = "";
                                                          let seniorprice = "";
                                                          if (
                                                            seniorTraveler > 0
                                                          ) {
                                                            if (
                                                              i.specialOffer !=
                                                              "no_offer"
                                                            ) {
                                                              let result = [];

                                                              i.specialOffer.map(
                                                                (l, j) => {
                                                                  if (
                                                                    l.combineoffer ==
                                                                    "nocombine"
                                                                  ) {
                                                                    if (
                                                                      l
                                                                        .specialdata
                                                                        .discount_id ==
                                                                      2
                                                                    ) {
                                                                      const disA =
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    } else {
                                                                      const disA =
                                                                        item.senior_price -
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    }
                                                                  } else {
                                                                    if (
                                                                      l
                                                                        .specialdata
                                                                        .discount_id ==
                                                                      2
                                                                    ) {
                                                                      const disA =
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    } else {
                                                                      const disA =
                                                                        item.senior_price -
                                                                        l
                                                                          .specialdata
                                                                          .rate_amount;
                                                                      result.push(
                                                                        +disA
                                                                      );
                                                                    }
                                                                  }
                                                                }
                                                              );

                                                              const Amount = result
                                                                .reduce(
                                                                  (a, v) =>
                                                                    a + v * 1,
                                                                  0
                                                                )
                                                                .toFixed(2);

                                                              const $UpliftAmountSenior =
                                                                (parseInt(
                                                                  i
                                                                    .priceuplift[0]
                                                                ) /
                                                                  100) *
                                                                item.senior_price;
                                                              const UpliftGroupSenior =
                                                                parseInt(
                                                                  item.senior_price
                                                                ) +
                                                                $UpliftAmountSenior;
                                                              const balanceAmount =
                                                                UpliftGroupSenior -
                                                                (
                                                                  Math.round(
                                                                    Amount *
                                                                      UpliftGroupSenior
                                                                  ) / 100
                                                                ).toFixed(2);
                                                              seniorprice = balanceAmount;
                                                            } else {
                                                              const $UpliftAmountSenior =
                                                                (parseInt(
                                                                  i
                                                                    .priceuplift[0]
                                                                ) /
                                                                  100) *
                                                                item.senior_price;
                                                              const UpliftGroupSenior =
                                                                parseInt(
                                                                  item.senior_price
                                                                ) +
                                                                $UpliftAmountSenior;
                                                              seniorprice = UpliftGroupSenior;
                                                            }
                                                            seniorTraveler == 1
                                                              ? (senior_P =
                                                                  seniorTraveler +
                                                                  " Senior x " +
                                                                  " <img src='images/euro.png' />" +
                                                                  seniorprice +
                                                                  "=" +
                                                                  " <img src='images/euro.png' />" +
                                                                  seniorprice *
                                                                    seniorTraveler +
                                                                  "<br/>")
                                                              : (senior_P =
                                                                  seniorTraveler +
                                                                  " Seniors x " +
                                                                  " <img src='images/euro.png' />" +
                                                                  seniorprice +
                                                                  "=" +
                                                                  " <img src='images/euro.png' />" +
                                                                  seniorprice *
                                                                    seniorTraveler +
                                                                  "<br/>");
                                                          }

                                                          total = ReactHtmlParser(
                                                            adult_P +
                                                              infant_P +
                                                              child_P +
                                                              youth_P +
                                                              senior_P
                                                          );

                                                          return total;
                                                        } else {
                                                          let adult_P = "";
                                                          let adultTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.adultCounter *
                                                                1,
                                                            0
                                                          );
                                                          let infantTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.infantCounter *
                                                                1,
                                                            0
                                                          );
                                                          let childTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.childCounter *
                                                                1,
                                                            0
                                                          );
                                                          let youthTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.youthCounter *
                                                                1,
                                                            0
                                                          );
                                                          let seniorTraveler = carts.reduce(
                                                            (a, v) =>
                                                              a +
                                                              v.seniorCounter *
                                                                1,
                                                            0
                                                          );
                                                          let adultprice = "";
                                                          if (
                                                            adultTraveler <=
                                                              item.adult_max &&
                                                            adultTraveler >=
                                                              item.adult_min
                                                          ) {
                                                            if (
                                                              adultTraveler > 0
                                                            ) {
                                                              if (
                                                                i.specialOffer !=
                                                                "no_offer"
                                                              ) {
                                                                let result = [];

                                                                i.specialOffer.map(
                                                                  (l, j) => {
                                                                    if (
                                                                      l.combineoffer ==
                                                                      "nocombine"
                                                                    ) {
                                                                      if (
                                                                        l
                                                                          .specialdata
                                                                          .discount_id ==
                                                                        2
                                                                      ) {
                                                                        const disA =
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      } else {
                                                                        const disA =
                                                                          item.adult_price -
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      }
                                                                    } else {
                                                                      if (
                                                                        l
                                                                          .specialdata
                                                                          .discount_id ==
                                                                        2
                                                                      ) {
                                                                        const disA =
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      } else {
                                                                        const disA =
                                                                          item.adult_price -
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      }
                                                                    }
                                                                  }
                                                                );

                                                                const Amount = result
                                                                  .reduce(
                                                                    (a, v) =>
                                                                      a + v * 1,
                                                                    0
                                                                  )
                                                                  .toFixed(2);
                                                                const $UpliftAmountAdult =
                                                                  (parseInt(
                                                                    i
                                                                      .priceuplift[0]
                                                                  ) /
                                                                    100) *
                                                                  item.adult_price;
                                                                const UpliftGroupAdult =
                                                                  parseInt(
                                                                    item.adult_price
                                                                  ) +
                                                                  $UpliftAmountAdult;
                                                                const balanceAmount =
                                                                  UpliftGroupAdult -
                                                                  (
                                                                    Math.round(
                                                                      Amount *
                                                                        UpliftGroupAdult
                                                                    ) / 100
                                                                  ).toFixed(2);
                                                                adultprice = balanceAmount;
                                                              } else {
                                                                const $UpliftAmountAdult =
                                                                  (parseInt(
                                                                    i
                                                                      .priceuplift[0]
                                                                  ) /
                                                                    100) *
                                                                  item.adult_price;
                                                                const UpliftGroupAdult =
                                                                  parseInt(
                                                                    item.adult_price
                                                                  ) +
                                                                  $UpliftAmountAdult;
                                                                adultprice = UpliftGroupAdult;
                                                              }
                                                              adultTraveler == 1
                                                                ? (adult_P =
                                                                    adultTraveler +
                                                                    " Adults x " +
                                                                    " <img src='images/euro.png' />" +
                                                                    adultprice +
                                                                    "=" +
                                                                    " <img src='images/euro.png' />" +
                                                                    (
                                                                      adultprice *
                                                                      adultTraveler
                                                                    ).toFixed(
                                                                      2
                                                                    ) +
                                                                    "<br/>")
                                                                : (adult_P =
                                                                    adultTraveler +
                                                                    " Adults x " +
                                                                    " <img src='images/euro.png' />" +
                                                                    adultprice +
                                                                    "=" +
                                                                    " <img src='images/euro.png' />" +
                                                                    (
                                                                      adultprice *
                                                                      adultTraveler
                                                                    ).toFixed(
                                                                      2
                                                                    ) +
                                                                    "<br/>");
                                                            }
                                                          }
                                                          let infant_P = "";
                                                          let infantprice = "";
                                                          if (
                                                            infantTraveler <=
                                                              item.infant_max &&
                                                            infantTraveler >=
                                                              item.infant_min
                                                          ) {
                                                            if (
                                                              infantTraveler > 0
                                                            ) {
                                                              if (
                                                                i.specialOffer !=
                                                                "no_offer"
                                                              ) {
                                                                let result = [];

                                                                i.specialOffer.map(
                                                                  (l, j) => {
                                                                    if (
                                                                      l.combineoffer ==
                                                                      "nocombine"
                                                                    ) {
                                                                      if (
                                                                        l
                                                                          .specialdata
                                                                          .discount_id ==
                                                                        2
                                                                      ) {
                                                                        const disA =
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      } else {
                                                                        const disA =
                                                                          item.infant_price -
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      }
                                                                    } else {
                                                                      if (
                                                                        l
                                                                          .specialdata
                                                                          .discount_id ==
                                                                        2
                                                                      ) {
                                                                        const disA =
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      } else {
                                                                        const disA =
                                                                          item.infant_price -
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      }
                                                                    }
                                                                  }
                                                                );

                                                                const Amount = result
                                                                  .reduce(
                                                                    (a, v) =>
                                                                      a + v * 1,
                                                                    0
                                                                  )
                                                                  .toFixed(2);

                                                                const $UpliftAmountInfant =
                                                                  (parseInt(
                                                                    i
                                                                      .priceuplift[0]
                                                                  ) /
                                                                    100) *
                                                                  item.infant_price;
                                                                const UpliftGroupInfant =
                                                                  parseInt(
                                                                    item.infant_price
                                                                  ) +
                                                                  $UpliftAmountInfant;

                                                                const balanceAmount =
                                                                  UpliftGroupInfant -
                                                                  (
                                                                    Math.round(
                                                                      Amount *
                                                                        UpliftGroupInfant
                                                                    ) / 100
                                                                  ).toFixed(2);
                                                                infantprice = balanceAmount;
                                                              } else {
                                                                const $UpliftAmountInfant =
                                                                  (parseInt(
                                                                    i
                                                                      .priceuplift[0]
                                                                  ) /
                                                                    100) *
                                                                  item.infant_price;
                                                                const UpliftGroupInfant =
                                                                  parseInt(
                                                                    item.infant_price
                                                                  ) +
                                                                  $UpliftAmountInfant;
                                                                infantprice = UpliftGroupInfant;
                                                              }
                                                              infantTraveler ==
                                                              1
                                                                ? (infant_P =
                                                                    infantTraveler +
                                                                    " Infant x " +
                                                                    " <img src='images/euro.png' />" +
                                                                    infantprice +
                                                                    "=" +
                                                                    " <img src='images/euro.png' />" +
                                                                    (
                                                                      infantprice *
                                                                      infantTraveler
                                                                    ).toFixed(
                                                                      2
                                                                    ) +
                                                                    "<br/>")
                                                                : (infant_P =
                                                                    infantTraveler +
                                                                    " Infants x " +
                                                                    " <img src='images/euro.png' />" +
                                                                    infantprice +
                                                                    "=" +
                                                                    " <img src='images/euro.png' />" +
                                                                    (
                                                                      infantprice *
                                                                      infantTraveler
                                                                    ).toFixed(
                                                                      2
                                                                    ) +
                                                                    "<br/>");
                                                            }
                                                          }
                                                          let child_P = "";
                                                          let childprice = "";
                                                          if (
                                                            childTraveler <=
                                                              item.child_max &&
                                                            childTraveler >=
                                                              item.child_min
                                                          ) {
                                                            if (
                                                              childTraveler > 0
                                                            ) {
                                                              if (
                                                                i.specialOffer !=
                                                                "no_offer"
                                                              ) {
                                                                let result = [];

                                                                i.specialOffer.map(
                                                                  (l, j) => {
                                                                    if (
                                                                      l.combineoffer ==
                                                                      "nocombine"
                                                                    ) {
                                                                      if (
                                                                        l
                                                                          .specialdata
                                                                          .discount_id ==
                                                                        2
                                                                      ) {
                                                                        const disA =
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      } else {
                                                                        const disA =
                                                                          item.child_price -
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      }
                                                                    } else {
                                                                      if (
                                                                        l
                                                                          .specialdata
                                                                          .discount_id ==
                                                                        2
                                                                      ) {
                                                                        const disA =
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      } else {
                                                                        const disA =
                                                                          item.child_price -
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      }
                                                                    }
                                                                  }
                                                                );

                                                                const Amount = result
                                                                  .reduce(
                                                                    (a, v) =>
                                                                      a + v * 1,
                                                                    0
                                                                  )
                                                                  .toFixed(2);
                                                                const $UpliftAmountChild =
                                                                  (parseInt(
                                                                    i
                                                                      .priceuplift[0]
                                                                  ) /
                                                                    100) *
                                                                  item.child_price;
                                                                const UpliftGroupChild =
                                                                  parseInt(
                                                                    item.child_price
                                                                  ) +
                                                                  $UpliftAmountChild;
                                                                const balanceAmount =
                                                                  UpliftGroupChild -
                                                                  (
                                                                    Math.round(
                                                                      Amount *
                                                                        UpliftGroupChild
                                                                    ) / 100
                                                                  ).toFixed(2);
                                                                childprice = balanceAmount;
                                                              } else {
                                                                const $UpliftAmountChild =
                                                                  (parseInt(
                                                                    i
                                                                      .priceuplift[0]
                                                                  ) /
                                                                    100) *
                                                                  item.child_price;
                                                                const UpliftGroupChild =
                                                                  parseInt(
                                                                    item.child_price
                                                                  ) +
                                                                  $UpliftAmountChild;
                                                                childprice = UpliftGroupChild;
                                                              }
                                                              childTraveler == 1
                                                                ? (child_P =
                                                                    childTraveler +
                                                                    " Child x " +
                                                                    " <img src='images/euro.png' />" +
                                                                    childprice +
                                                                    "=" +
                                                                    " <img src='images/euro.png' />" +
                                                                    (
                                                                      childprice *
                                                                      childTraveler
                                                                    ).toFixed(
                                                                      2
                                                                    ) +
                                                                    "<br/>")
                                                                : (child_P =
                                                                    childTraveler +
                                                                    " Childs x " +
                                                                    " <img src='images/euro.png' />" +
                                                                    childprice +
                                                                    "=" +
                                                                    " <img src='images/euro.png' />" +
                                                                    (
                                                                      childprice *
                                                                      childTraveler
                                                                    ).toFixed(
                                                                      2
                                                                    ) +
                                                                    "<br/>");
                                                            }
                                                          }
                                                          let youth_P = "";
                                                          let youthprice = "";
                                                          if (
                                                            youthTraveler <=
                                                              item.youth_max &&
                                                            youthTraveler >=
                                                              item.youth_min
                                                          ) {
                                                            if (
                                                              youthTraveler > 0
                                                            ) {
                                                              if (
                                                                i.specialOffer !=
                                                                "no_offer"
                                                              ) {
                                                                let result = [];

                                                                i.specialOffer.map(
                                                                  (l, j) => {
                                                                    if (
                                                                      l.combineoffer ==
                                                                      "nocombine"
                                                                    ) {
                                                                      if (
                                                                        l
                                                                          .specialdata
                                                                          .discount_id ==
                                                                        2
                                                                      ) {
                                                                        const disA =
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      } else {
                                                                        const disA =
                                                                          item.youth_price -
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      }
                                                                    } else {
                                                                      if (
                                                                        l
                                                                          .specialdata
                                                                          .discount_id ==
                                                                        2
                                                                      ) {
                                                                        const disA =
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      } else {
                                                                        const disA =
                                                                          item.youth_price -
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      }
                                                                    }
                                                                  }
                                                                );

                                                                const Amount = result
                                                                  .reduce(
                                                                    (a, v) =>
                                                                      a + v * 1,
                                                                    0
                                                                  )
                                                                  .toFixed(2);

                                                                const $UpliftAmountYouth =
                                                                  (parseInt(
                                                                    i
                                                                      .priceuplift[0]
                                                                  ) /
                                                                    100) *
                                                                  item.youth_price;
                                                                const UpliftGroupYouth =
                                                                  parseInt(
                                                                    item.youth_price
                                                                  ) +
                                                                  $UpliftAmountYouth;
                                                                const balanceAmount =
                                                                  UpliftGroupYouth -
                                                                  (
                                                                    Math.round(
                                                                      Amount *
                                                                        UpliftGroupYouth
                                                                    ) / 100
                                                                  ).toFixed(2);
                                                                youthprice = balanceAmount;
                                                              } else {
                                                                const $UpliftAmountYouth =
                                                                  (parseInt(
                                                                    i
                                                                      .priceuplift[0]
                                                                  ) /
                                                                    100) *
                                                                  item.youth_price;
                                                                const UpliftGroupYouth =
                                                                  parseInt(
                                                                    item.youth_price
                                                                  ) +
                                                                  $UpliftAmountYouth;
                                                                youthprice = UpliftGroupYouth;
                                                              }
                                                              youthTraveler == 1
                                                                ? (youth_P =
                                                                    youthTraveler +
                                                                    " Youth x " +
                                                                    " <img src='images/euro.png' />" +
                                                                    youthprice +
                                                                    "=" +
                                                                    " <img src='images/euro.png' />" +
                                                                    (
                                                                      youthprice *
                                                                      youthTraveler
                                                                    ).toFixed(
                                                                      2
                                                                    ) +
                                                                    "<br/>")
                                                                : (youth_P =
                                                                    youthTraveler +
                                                                    " Youths x " +
                                                                    " <img src='images/euro.png' />" +
                                                                    youthprice +
                                                                    "=" +
                                                                    " <img src='images/euro.png' />" +
                                                                    (
                                                                      youthprice *
                                                                      youthTraveler
                                                                    ).toFixed(
                                                                      2
                                                                    ) +
                                                                    "<br/>");
                                                            }
                                                          }
                                                          let senior_P = "";
                                                          let seniorprice = "";
                                                          if (
                                                            seniorTraveler <=
                                                              item.senior_max &&
                                                            seniorTraveler >=
                                                              item.senior_min
                                                          ) {
                                                            if (
                                                              seniorTraveler > 0
                                                            ) {
                                                              if (
                                                                i.specialOffer !=
                                                                "no_offer"
                                                              ) {
                                                                let result = [];

                                                                i.specialOffer.map(
                                                                  (l, j) => {
                                                                    if (
                                                                      l.combineoffer ==
                                                                      "nocombine"
                                                                    ) {
                                                                      if (
                                                                        l
                                                                          .specialdata
                                                                          .discount_id ==
                                                                        2
                                                                      ) {
                                                                        const disA =
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      } else {
                                                                        const disA =
                                                                          item.senior_price -
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      }
                                                                    } else {
                                                                      if (
                                                                        l
                                                                          .specialdata
                                                                          .discount_id ==
                                                                        2
                                                                      ) {
                                                                        const disA =
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      } else {
                                                                        const disA =
                                                                          item.senior_price -
                                                                          l
                                                                            .specialdata
                                                                            .rate_amount;
                                                                        result.push(
                                                                          +disA
                                                                        );
                                                                      }
                                                                    }
                                                                  }
                                                                );

                                                                const Amount = result
                                                                  .reduce(
                                                                    (a, v) =>
                                                                      a + v * 1,
                                                                    0
                                                                  )
                                                                  .toFixed(2);
                                                                const $UpliftAmountSenior =
                                                                  (parseInt(
                                                                    i
                                                                      .priceuplift[0]
                                                                  ) /
                                                                    100) *
                                                                  item.senior_price;
                                                                const UpliftGroupSenior =
                                                                  parseInt(
                                                                    item.senior_price
                                                                  ) +
                                                                  $UpliftAmountSenior;
                                                                const balanceAmount =
                                                                  UpliftGroupSenior -
                                                                  (
                                                                    Math.round(
                                                                      Amount *
                                                                        UpliftGroupSenior
                                                                    ) / 100
                                                                  ).toFixed(2);
                                                                seniorprice = balanceAmount;
                                                              } else {
                                                                const $UpliftAmountSenior =
                                                                  (parseInt(
                                                                    i
                                                                      .priceuplift[0]
                                                                  ) /
                                                                    100) *
                                                                  item.senior_price;
                                                                const UpliftGroupSenior =
                                                                  parseInt(
                                                                    item.senior_price
                                                                  ) +
                                                                  $UpliftAmountSenior;
                                                                seniorprice = UpliftGroupSenior;
                                                              }
                                                              seniorTraveler ==
                                                              1
                                                                ? (senior_P =
                                                                    seniorTraveler +
                                                                    " Senior x " +
                                                                    " <img src='images/euro.png' />" +
                                                                    seniorprice +
                                                                    "=" +
                                                                    " <img src='images/euro.png' />" +
                                                                    (
                                                                      seniorprice *
                                                                      seniorTraveler
                                                                    ).toFixed(
                                                                      2
                                                                    ) +
                                                                    "<br/>")
                                                                : (senior_P =
                                                                    seniorTraveler +
                                                                    " Seniors x " +
                                                                    " <img src='images/euro.png' />" +
                                                                    seniorprice +
                                                                    "=" +
                                                                    " <img src='images/euro.png' />" +
                                                                    (
                                                                      seniorprice *
                                                                      seniorTraveler
                                                                    ).toFixed(
                                                                      2
                                                                    ) +
                                                                    "<br/>");
                                                            }
                                                          }

                                                          total = ReactHtmlParser(
                                                            adult_P +
                                                              infant_P +
                                                              child_P +
                                                              youth_P +
                                                              senior_P
                                                          );

                                                          return total;
                                                        }
                                                      }
                                                    }
                                                  )}
                                                </span>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              } else {
                                if (i == "no_priceoption") {
                                  return (
                                    <>
                                      <div className="pax-container d-flex container px-0 flex-column flex-lg-row">
                                        <div className="tg-container-left d-flex flex-column align-items-start p-lg-4 px-3 pt-3 pb-4  long-button ">
                                          <div className="tour-option-details w-100">
                                            <div
                                              className="description-wrapper d-flex py-3 ie-overflow-fix"
                                              data-description-preview-length="300"
                                            >
                                              <div
                                                className="tg-description"
                                                style={{
                                                  fontSize: 16,
                                                  fontWeight: 600,
                                                }}
                                              >
                                                <div class="noavailable">
                                                  <b>
                                                    The experience is not
                                                    available on this day.
                                                    Kindly select another day.
                                                  </b>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  );
                                }
                              }
                            })}
                          </>
                        ) : (
                          <>
                            <div className="pax-container d-flex container px-0 flex-column flex-lg-row">
                              <div className="tg-container-left d-flex flex-column align-items-start p-lg-4 px-3 pt-3 pb-4  long-button ">
                                <div className="tour-option-details w-100">
                                  <div
                                    className="description-wrapper d-flex py-3 ie-overflow-fix"
                                    data-description-preview-length="300"
                                  >
                                    <div className="tg-description">
                                      <div class="noavailable">
                                        The experience is not available on this
                                        day. Kindly select another day.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <></>
                )}

                      </div>
                    </div>
                  </div>
                  
                  <div id="Inclusions" className="appendTop20 scrollMargin100 ">
                   
                        <div
                  className="container"
                  style={{ maxWidth: "1210px", marginBottom: 30, marginTop: '10px' }}
                >
                  <Collapsible trigger="Transportation Details" triggerClassName="txtHeading font16 latoBlack blackText textHeader" triggerOpenedClassName="txtHeading font16 latoBlack blackText textHeader" className="accordionCollapsed">
                  {tourTransportDetails == null ? (
                    <div className="">
                      <h3 className="font-weight-bold text-bodyNew">Transport Details</h3>

                      <div style={{ marginTop: 20 }}></div>
                    </div>
                  ) : (
                    <div className="">
                      <h3 className="font-weight-bold text-bodyNew">Transport Details</h3>

                      <div style={{ marginTop: 0 }}>
                        {/* {tourTransportDetails.location
                          .pickup_location != "no_location" &&
                          tourTransportDetails.location.pickup_location[0].map(
                            (i, j) => {
                              return (
                                <>
                                  <div className="mettingPointListing">
                                    <FontAwesomeIcon
                                      icon={
                                       i.pickup_from_id ==
                                        1
                                          ? faPlane
                                          :i.pickup_from_id ==
                                            2
                                          ? faBus
                                          :i.pickup_from_id ==
                                            3
                                          ? faShip
                                          : faMapMarkedAlt
                                      }
                                      className="mettingPickupCheck"
                                    />
                                    <p className="mettingPickupAddress">
                                    {i.pickup_address_from} <span>To</span> {i.pickup_address_to}
                                    </p>
                                  </div>
                                </>
                              );
                            }
                          )} */}

                        {tourTransportDetails.transport.transport_details
                          != "no_tansportdetails" &&
                          tourTransportDetails.transport.transport_details[0].map(
                            (i, j) => {
                              return (
                                <>

                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                  
                                  </div>

                                  <h3 className="font-weight-bold text-bodyNew">
                                    Duration: {i?.flexible_id == 1 ? (<>{i?.flexible_min_hours} - {i?.flexible_max_hours} {i.flexible_time ==1?"Minutes":"Hours"}
                                    </>) : (<>{i?.normal_hours} Hours  {i?.normal_minutes} Minutes</>)}
                                  </h3>

                                  {/* <section class="sectionWrapper">
                                    <h3 class="section-title">Details</h3><div class="description text-pre-wrap" itemprop="description">{ReactHtmlParser(i.transport_description)}</div>
                                  </section> */}
                                  <div className="description text-pre-wrap">
                                  {ReactHtmlParser(i.transport_description)}
                                  </div>
                                </>
                              );
                            }
                          )}
                      </div>
                    </div>
                  )}

                </Collapsible>
                </div>

                <div
                  className="container"
                  style={{ maxWidth: "1210px", marginBottom: 30 }}
                >
                  <Collapsible
                              trigger="Inclusions and Exclusions"
                              triggerClassName="txtHeading font16 latoBlack blackText textHeader"
                              triggerOpenedClassName="txtHeading font16 latoBlack blackText textHeader"
                              className="accordionCollapsed"
                            >
                                <div id="Inclusions" className="appendTop5 scrollMargin100 ">
                              <div className="appendBottom20 appendLeft15">
                                <div className="font14 latoBlack blackText appendBottom10">
                                  Inclusions/Exclusions
                                </div>
                                <ul className="appendBottom15">
                                {tourInclusionDetails != null && tourInclusionDetails.map((i, j) => {
                                  if (i.category_name != null) {
                                    return (
                                  <li>
                                    {" "}
                                    <p className="appendLeft10 appendBottom3 relative font12 appendBottom8">
                                      <span className="appendRight5 green-check-mark">
                                        ✔
                                      </span>
                                      {i.category_name} -{" "}
                                      {i.tour_inclusion_description && (<>({i.tour_inclusion_description})</>)}
                                    </p>
                                  </li>
                                    );
                                    }
                                  })}
                                </ul>
                                <ul className="">
                                {tourExclusionDetails != null && tourExclusionDetails.map((i, j) => {
                                  return (
                                  <li>
                                    <p className="appendLeft10 appendBottom3 relative font12 appendBottom8">
                                      <span className="appendRight5 cross-mark">✘</span>
                                      {i.category_name != null &&i.category_name.trim()} -{" "}{i.tour_exclusion_description && (<>({i.tour_exclusion_description})</>)}
                                    </p>
                                  </li>
                                    );
                                })}
                                </ul>
                              </div>
                            </div>
                  </Collapsible>
                </div>
                <div
                  className="container"
                  style={{ maxWidth: "1210px", marginBottom: 30 }}
                >
                  <Collapsible
                              trigger="Meeting Points"
                              triggerClassName="txtHeading font16 latoBlack blackText textHeader"
                              triggerOpenedClassName="txtHeading font16 latoBlack blackText textHeader"
                              className="accordionCollapsed"
                            >
                              {tourMeetingpointDetails.meeting_point !=
                              "no_meetingPoint" ? (
                                <div className="">
                                  <div className="meetingPint">
                                    <h2 className="txtHeading font16 latoBlack blackText">
                                      Pickup Available for all travelers
                                    </h2>
                                    <h3 className="greenText latoBold font14 extraSpacing">
                                      Pickup Point
                                    </h3>
                                    {tourMeetingpointDetails.meeting_point &&
                                      tourMeetingpointDetails.meeting_point !=
                                        "no_multiple_points" &&
                                      tourMeetingpointDetails.meeting_point[0].map(
                                        (i, j) => {
                                          return (
                                            <>
                                              <div className="mettingPointListing">
                                                <FontAwesomeIcon
                                                  icon={faMapMarkedAlt}
                                                  className="mettingPickupCheck"
                                                />
                                                <p className="mettingPickupAddress">
                                                  {i.start_point_address}
                                                </p>
                                              </div>

                                              <div className="sectionWrapper">
                                                <div className="description text-pre-wrap">
                                                  {i.start_point_description !=
                                                  ""
                                                    ? i.start_point_description
                                                    : ""}
                                                </div>
                                              </div>
                                            </>
                                          );
                                        }
                                      )}
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  ></div>
                                  <h3 className="greenText latoBold font14 extraSpacing">
                                    Return Details
                                  </h3>
                                  {tourMeetingpointDetails.meeting_point &&
                                    tourMeetingpointDetails.meeting_point !=
                                      "no_multiple_points" &&
                                    tourMeetingpointDetails.meeting_point[0].map(
                                      (i, j) => {
                                        return (
                                          <>
                                            <div className="mettingPointListing">
                                              <FontAwesomeIcon
                                                icon={faMapMarkedAlt}
                                                className="mettingPickupCheck"
                                              />
                                              <p className="mettingPickupAddress">
                                                {i.end_point_address != ""
                                                  ? i.end_point_address
                                                  : "Returns to original departure point"}
                                              </p>
                                            </div>

                                            <div className="sectionWrapper">
                                              <div className="description text-pre-wrap">
                                                {i.end_point_description != ""
                                                  ? i.end_point_description
                                                  : ""}
                                              </div>
                                            </div>
                                          </>
                                        );
                                      }
                                    )}
                                </div>
                              ) : (
                                <div className="meetingPint">
                                  <h2 className="txtHeading font16 latoBlack blackText">
                                    Pickup Available for all travelers
                                  </h2>
                                  <h3 className="greenText latoBold font14 extraSpacing">
                                    Pickup Point
                                  </h3>

                                  <div style={{ marginTop: 20 }}>
                                    {tourMeetingpointDetails.pickup_location !=
                                      "no_pickupLocation" &&
                                      tourMeetingpointDetails.pickup_location.map(
                                        (i, j) => {
                                          return (
                                            <>
                                              {i.map((res, index) => {
                                                return (
                                                  <>
                                                    <div className="mettingPointListing">
                                                      <FontAwesomeIcon
                                                        icon={
                                                          res.pickup_from_id ==
                                                          1
                                                            ? faHotel
                                                            : res.pickup_from_id ==
                                                              2
                                                            ? faShip
                                                            : res.pickup_from_id ==
                                                              3
                                                            ? faPlane
                                                            : faMapMarkedAlt
                                                        }
                                                        className="mettingPickupCheck"
                                                      />
                                                      <p className="mettingPickupAddress">
                                                        {res.pickup_address}
                                                      </p>
                                                    </div>
                                                  </>
                                                );
                                              })}
                                            </>
                                          );
                                        }
                                      )}
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    {tourPriceDetails != null &&
                                      tourPriceDetails.timing !=
                                        "coordinated_times" &&
                                      tourPriceDetails.timing.map((i, j) => (
                                        <p style={{ marginRight: 10 }}></p>
                                      ))}
                                  </div>
                                  <p>
                                    Pickup commence approximately{" "}
                                    {tourMeetingpointDetails.meeting_point ==
                                      "no_meetingPoint" &&
                                      tourMeetingpointDetails.pickup_details ==
                                        "no_pickup_details" && <>---</>}
                                    {(tourMeetingpointDetails.meeting_point !=
                                      "no_meetingPoint" &&
                                      tourMeetingpointDetails
                                        .pickup_location_details[0]
                                        .pickup_window_time) ||
                                      ""}{" "}
                                    {tourMeetingpointDetails.pickup_details !=
                                      "no_pickup_details" &&
                                      tourMeetingpointDetails.pickup_details.map(
                                        (i, j) => {
                                          return (
                                            <>
                                              {i.map((res, index) => {
                                                return (
                                                  <>{res.pickup_window_time}</>
                                                );
                                              })}
                                            </>
                                          );
                                        }
                                      )}
                                    &nbsp; minutes prior to the departure time.
                                  </p>
                                  {tourMeetingpointDetails.pickup_details !=
                                    "no_pickup_details" &&
                                    tourMeetingpointDetails.pickup_details.map(
                                      (i, j) => {
                                        return (
                                          <>
                                            {i.map((res, index) => {
                                              return (
                                                <>
                                                  <h3 className="greenText latoBold font14 extraSpacing">
                                                    Pickup details
                                                  </h3>
                                                  <p>
                                                    {" "}
                                                    {res.pickup_description}
                                                  </p>
                                                </>
                                              );
                                            })}
                                          </>
                                        );
                                      }
                                    )}
                                </div>
                              )}
                  </Collapsible>
                </div>

                <div
                  className="container"
                  style={{ maxWidth: "1210px", marginBottom: 30 }}
                >
                  <Collapsible
                    trigger="Policies"
                    triggerClassName="txtHeading font16 latoBlack blackText textHeader"
                    triggerOpenedClassName="txtHeading font16 latoBlack blackText textHeader"
                    className="accordionCollapsed"
                  >
                    {tourCancellationPolicyDetails != null &&
                      tourCancellationPolicyDetails.cancellation_policy.map(
                        (item, index) => {
                          if (item[0].cancellation_penalty_id == 1) {
                            return (
                              <div>
                                <div className="latoRegular font16 appendBottom15">
                                  <b>
                                    {getDateModal(item)}
                                    ‬&#x202C;
                                  </b>
                                </div>
                              </div>
                            );
                          } else {
                            return (
                              <>
                                <div className="latoRegular font16 appendBottom15">
                                  <b>
                                    The cancellation charges will be applicable
                                    as follows
                                  </b>
                                </div>
                                <div className="cncpolicyTbl">
                                  <div className="cncpolicyTbl__head">
                                    <div className="cncpolicyTbl__col">
                                      Days Before Arrivals{" "}
                                    </div>
                                    <div className="cncpolicyTbl__col">
                                      Charges{" "}
                                    </div>
                                  </div>
                                  {CancellationModal(item)}
                                </div>
                              </>
                            );
                          }
                        }
                      )}

                    {tourCancellationPolicyDetails != null &&
                      tourCancellationPolicyDetails.cancellation_policy.map(
                        (item, index) => {
                          if (item[0].policy_text != null) {
                            return (
                              <>
                                {" "}
                                <section class="sectionWrapper">
                                  <h3 class="section-title">More Details</h3>
                                  <div
                                    class="description text-pre-wrap"
                                    itemprop="description"
                                  >
                                    {ReactHtmlParser(item[0].policy_text)}
                                  </div>
                                </section>
                              </>
                            );
                          }
                        }
                      )}
                  </Collapsible>
                </div>

                <div
                  className="container"
                  style={{ maxWidth: "1210px", marginBottom: 30 }}
                >
                  <Collapsible
                    trigger="More"
                    triggerClassName="txtHeading font16 latoBlack blackText textHeader"
                    triggerOpenedClassName="txtHeading font16 latoBlack blackText textHeader"
                    className="accordionCollapsed"
                  >
                    <section class="sectionWrapper" style={{ padding: 0 }}>
                      <div
                        class="description text-pre-wrap"
                        itemprop="description"
                      >
                        {ReactHtmlParser(
                          tourDescriptionDetails.tour_additional_info
                        )}
                      </div>
                    </section>
                  </Collapsible>
                </div>
                  </div>
                  <div
                    id="Location"
                    className="appendBottom20 paddingLR15"
                  ></div>
                  <div
                    id="Terms_and_Conditions"
                    className="appendBottom50 paddingLR15"
                  ></div>
                  <div className="marginBottom100"></div>
                  <div className="activityBottom"></div>
                  </>)}
                  </>)}
                </div>)}
              </>
            ) : (
              <>
                {openAttractionDetails == "ACCL" ? (
                  <>
                    <div
                      className="sidePanelWrap"
                      data-testid="activity-details"
                    >
                      <div className="sidePanelTopSection activityHeader">
                        <div className="makeFlex spaceBetween hrtlCenter">
                          <div className="">
                            <span className="font20 blackText latoBlack ">
                              Add Ferry Transfer
                            </span>
                          </div>
                          {/* <div className="searchBarWrapper">
                            <span className="overlaySprite searchIcon"></span>
                            <div className="flex">
                              <div className="searchBarContainer">
                                <input
                                  className="font11 searchInput"
                                  placeholder="Search by Transfer name"
                                  value=""
                                />
                              </div>
                            </div>
                          </div> */}
                        </div>
                        {/* <div className="activityFliterOuter">
                          <div className="filterWrapper appendTop15">
                            <div className="multiSelectFilterWrapper">
                              <label className="labelName font11">Theme</label>
                              <div
                                id="multiSelectContainer_undefined"
                                className="multiSelectContainer "
                              >
                                <div className="multiSelectInput ">
                                  <span className="selectedValues font11">
                                    Any
                                  </span>
                                  <span className="dropdownIcon "></span>
                                </div>
                              </div>
                            </div>
                            <div className="multiSelectFilterWrapper">
                              <label className="labelName font11">
                                Category
                              </label>
                              <div
                                id="multiSelectContainer_undefined"
                                className="multiSelectContainer "
                              >
                                <div className="multiSelectInput ">
                                  <span className="selectedValues font11">
                                    Any
                                  </span>
                                  <span className="dropdownIcon "></span>
                                </div>
                              </div>
                            </div>
                            <div className="makeFlex">
                              <div className="flexOne multicitySlider">
                                <div className="priceFilter">
                                  <p className="appendBottom15 font11">
                                    <span className="latoBlack font14">
                                      Price Range{" "}
                                    </span>{" "}
                                    (+1 to +5,884)
                                  </p>
                                  <div className="rangeSlider">
                                    <div className="rc-slider">
                                      <div className="rc-slider-rail"></div>
                                      <div
                                        className="rc-slider-track rc-slider-track-1"
                                        style={{
                                          height: "6px",
                                          left: "0%",
                                          right: "auto",
                                          width: "100%",
                                        }}
                                      ></div>
                                      <div className="rc-slider-step"></div>
                                      <div
                                        tabindex="0"
                                        className="rc-slider-handle rc-slider-handle-1"
                                        role="slider"
                                        aria-valuemin="1"
                                        aria-valuemax="5884"
                                        aria-valuenow="1"
                                        aria-disabled="false"
                                        style={{
                                          width: "24px",
                                          height: "24px",
                                          borderStyle: "solid",
                                          borderWidth: "1px",
                                          borderColor: "rgb(188, 188, 188)",
                                          borderRadius: "20px",
                                          marginTop: "-9px",
                                          boxShadow: "none",
                                          left: "0%",
                                          right: "auto",
                                          transform: "translateX(-50%)",
                                        }}
                                      ></div>
                                      <div
                                        tabindex="0"
                                        className="rc-slider-handle rc-slider-handle-2"
                                        role="slider"
                                        aria-valuemin="1"
                                        aria-valuemax="5884"
                                        aria-valuenow="5884"
                                        aria-disabled="false"
                                        style={{
                                          width: "24px",
                                          height: "24px",
                                          borderStyle: "solid",
                                          borderWidth: "1px",
                                          borderColor: "rgb(188, 188, 188)",
                                          borderRadius: "20px",
                                          marginTop: "-9px",
                                          boxShadow: "none",
                                          left: "100%",
                                          right: "auto",
                                          transform: "translateX(-50%)",
                                        }}
                                      ></div>
                                      <div className="rc-slider-mark"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}
                        <div className="sortByFilterWrapper">
                          <div className="filterMessage font12">
                          
                            {transferData === null ? (<>
                                <span style={{ color: "#55575b", paddingTop: 0 }}>{totalcount != 0 ? totalcount +" results": ""}</span>
                                </>
                              ) : (
                                <>{transferData == "no_transfer" ? (<></>
                                  ) : (
                                    <><span style={{ color: "#55575b", paddingTop: 0 }}>{transferData.length == 1? "1 result":"Showing "+ transferData.filter(i => i != 'no_transfer').length + " results"}
                                      </span>
                                    </>
                                  )}
                                </>
                              )}
                          </div>
                          {transferData != null && transferData != "no_transfer" &&(
                          <div className="sortByFilterContainer makeFlex">
                            <span className="sortbyHeading font12">
                              &nbsp;|&nbsp;Sort by
                            </span>
                           
                              <div className="filterNameWrapper">
                                <span className="filterName font12" onClick={showSorting}>
                                  &nbsp;{sortingSelectTour}
                                </span>
                                <span className="dropdownIcon "></span>
                              </div>
                              {transferData != null && transferData != "no_transfer" && sorting &&(
                                  <ul class="dropdownList">
                                    {SortArr.map((item, index) => (
                                      <li
                                        className={sortingSelectTour == item.name
                                            ? "optionNameConatiner font12 selected"
                                            : "optionNameConatiner font12"
                                        }
                                        key={index}
                                        onClick={() => handleSortingChange(item)}
                                      >
                                      <span class="optionValue">
                                        {item.name}
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                          </div>
                          )}
                        </div>
                      </div>
                      <div className="activityBodyContainer showBadge">
                        <div className="sidePanelBody">
                        {transferData === null  ? (
                          <>
                          <ListingSkeleton/>
                          <ListingSkeleton/>
                          <ListingSkeleton/> 
                          </>
                        ) :  transferData == "no_transfer" || transferData == undefined ? (
                         <>
                         <div className="">
                            <div className="row">
                                <div className="col-md-12 col-sm-12 col-lg-12">
                                    <div className="d-flax justifi-content-center">
                                        <div className="images-part">
                                        <img src={"images/noHotel.png"} style={{ margin: "0 auto" }}/>
                                        </div>
                                        <div className="soldoutcontent">
                                            <h3>We're sorry</h3>
                                            <p>This ferry tranfer is not available at this moment. Please try again later or look for an alternative ferry tranfer. </p>

                                            {/* <Link to="/home">
                                            <span className="hsw_searchButtonList">Search again</span>
                                            </Link> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                          </div>
                         </>
                        ) : (<>

                        {transferData.map((i, j) => {
                              if (i != "no_transfer") {
                                return (
                                  <>
                                    {Object.values(i).map((key1, index) => {
                                    
                                      const specialOffer = key1?.specialOffer;
                                      const forMeal = key1?.forMeal;
                                      const tour_price = key1?.tour_price;
                                      return (
                                        <>
                                          <div className="activityCardWrapper  " data-testid="activity-listing">
                                            <div className="activityPanel_leftContainer">
                                              <div className="imageWrapper">
                                                <div className="listing-carousel">
                                                  <div className="slick-slider slick-initialized">
                                                    <div className="slick-list">
                                                      <div
                                                        className="slick-track"
                                                        style={{
                                                          width: "208px",
                                                          opacity: 1,
                                                          transform: "translate3d(0px, 0px, 0px)",
                                                        }}
                                                      >
                                                        <div
                                                          data-index="0"
                                                          className="slick-slide slick-active slick-current"
                                                          tabindex="-1"
                                                          aria-hidden="false"
                                                          style={{
                                                            outline: "none",
                                                            width: "208px",
                                                          }}
                                                        >
                                                          <div>
                                                            <div
                                                              tabindex="-1"
                                                              style={{
                                                                width: "100%",
                                                                display: "inline-block",
                                                              }}
                                                            >
                                                              <div className="imageLoaderContainer ">
                                                                {key1.tour_gallery != null ? (
                                                                  key1.tour_gallery
                                                                    .slice(0, 1)
                                                                    .map((item, key) => (
                                                                      <LazyLoadImage
                                                                        src={
                                                                          ImageChanger == null ? item : ImageChanger
                                                                        }
                                                                        className="listing-carousel-slide active "
                                                                        placeholderSrc={
                                                                          process.env.PUBLIC_URL +
                                                                          "images/placeholder.png"
                                                                        }
                                                                        key={key}
                                                                      />
                                                                    ))
                                                                ) : (
                                                                  <LazyLoadImage src={"images/placeholder.png"} />
                                                                )}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="activityPanel_rightContainer">
                                              <div className="flex badges">
                                                <a  className="viewDetails"   onClick={() => detailsPageData(key1?.tour_data?.id, selectActivityDayNewDetails, countDetails+1) }>
                                                  VIEW DETAILS
                                                </a>
       
                                              </div>
                                              <div className="flex">
                                                <div className="flex column">
                                                  <h3 className="activityHeading">
                                                    {key1?.tour_data.tour_name.substring(0, 80)}
                                                  </h3>
                                                  <p className="address" style={{ color: "gray" }}>
                                                    {key1?.tour_data.tour_region_name != null ? (
                                                      <>
                                                        {key1?.tour_data.tour_location}, {key1?.tour_data.tour_region_name}
                                                      </>
                                                    ) : (
                                                      <>{key1?.tour_data.tour_location}</>
                                                    )}
                                                  </p>
                                                  <p className="activityDescription font10">
                                                    <span className="makeAllInline">
                                                
                                                    {key1?.tour_description?.tour_description !=null ?(<p
                                                          style={{
                                                            fontSize: "12px",
                                                            color: "#555",
                                                            marginTop: 8,
                                                            textAlign: "justify",
                                                            marginRight: 15,
                                                          }}
                                                        >
                                                          {key1?.tour_description?.tour_description?.substring(0, 200)}...
                                                        </p>): (
                                                        <p
                                                          style={{
                                                            fontSize: "12px",
                                                            color: "#555",
                                                            marginTop: 8,
                                                            textAlign: "justify",
                                                            marginRight: 15,
                                                          }}
                                                        >
                                                          {ReactHtmlParser(
                                                            `${key1?.tour_description?.tour_overview?.substring(0, 200)}...`
                                                          )}
                                                        </p>
                                                      )}
                                                    </span>
                                                  </p>
                                                </div>
                                                <div className="charges font20">
                                                  <p className="appendBottom5"><span className="font-weight-bold from-price-text">
                                                  {key1?.tour_price_details !=
                                                        null &&
                                                        key1?.tour_price_details
                                                          .slice(0, 1)
                                                          .map(
                                                            (
                                                              tour_price_category,
                                                              index
                                                            ) => (
                                                              <>
                                                                {tour_price_category.price_plan_id ==
                                                                  1 ||
                                                                tour_price_category.price_type_id !=
                                                                  0 ? (
                                                                  tour_price_category.price_type_id ==
                                                                  1 ? (
                                                                    <>
                                                                      Per Person
                                                                    </>
                                                                  ) : (
                                                                    <>
                                                                      Per Group
                                                                      (up to{" "}
                                                                      {
                                                                        tour_price_category.group_max
                                                                      }
                                                                      )
                                                                    </>
                                                                  )
                                                                ) : (
                                                                  <>Free </>
                                                                )}{" "}
                                                                {tour_price_category.flexible_id ==
                                                                1 ? (
                                                                  <>
                                                                    or Flexible
                                                                    rates
                                                                  </>
                                                                ) : (
                                                                  <></>
                                                                )}
                                                              </>
                                                            )
                                                          )}
                                                    </span>
                                                  </p>
                                                  {getAmount(specialOffer, forMeal, tour_price)}
                                                  {/* <span className="perPerson font12"> {key1?.tour_price_details !=
                                                        null &&
                                                        key1?.tour_price_details
                                                          .slice(0, 1)
                                                          .map(
                                                            (
                                                              tour_price_category,
                                                              index
                                                            ) => (
                                                              <>
                                                                {tour_price_category.price_plan_id ==
                                                                  1 ||
                                                                tour_price_category.price_type_id !=
                                                                  0 ? (
                                                                  tour_price_category.price_type_id ==
                                                                  1 ? (
                                                                    <>
                                                                      Per Person
                                                                    </>
                                                                  ) : (
                                                                    <>
                                                                      Per Group
                                                                      (up to{" "}
                                                                      {
                                                                        tour_price_category.group_max
                                                                      }
                                                                      )
                                                                    </>
                                                                  )
                                                                ) : (
                                                                  <>Free </>
                                                                )}{" "}
                                                                {tour_price_category.flexible_id ==
                                                                1 ? (
                                                                  <>
                                                                    or Flexible
                                                                    rates
                                                                  </>
                                                                ) : (
                                                                  <></>
                                                                )}
                                                              </>
                                                            )
                                                          )}</span> */}
                                                </div>
                                              </div>
                                              {key1?.freeroomCancellation[0]?.freecancelled &&(<div className="hGXiWF">Free cancellation</div>)}
                                              {key1?.tour_data?.tour_multiple_region_name != null ? (<div className="hGXiWF">{JSON.parse(key1?.tour_data?.tour_multiple_region_name).map((item, index) => { const comma = index === key1?.tour_data?.tour_multiple_region_name.length - 1 ? '' : ', '; return item + comma;}).join(' ')}</div>) : (<></>)}
                                              <div className="activityPanel_rightContainerFooter flex">
                                                {/* <span className="primaryBtn fill selectBtn">Select</span> */}
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      );
                                      })}
                                  </>
                                );
                              }
                            })}
                        
                        </>
                          )}
                         
                        
                        </div>
                      </div>
                      <div className="activityBottom"></div>
                    </div>
                  </>
                ) : (
                  <>
                    {openAttractionDetails == "ACCF" ? (
                      <>
                       
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
}
export default ExperienceTransferFerryListingPopup;
